import { Component, OnInit, Output, EventEmitter, ElementRef,
  Input, OnChanges, SimpleChanges, ChangeDetectorRef, ViewRef, ViewChild, DoCheck, HostListener, 
  ViewChildren, QueryList} from '@angular/core';
import { ApiService } from '../../../../@core/service/api.service';
import { formatCurrency, DatePipe } from '@angular/common';
import { OfferStatusData, ActionPointData, CompilationTypeData, DeliveryConditionsData, TaxHintData, DocConfig, IssuerData, PackingStatusData, FiscalYearData, UnitData, PaymentDates } from '../../../../@models/erp/compilationData';
import { CommonPrinter } from './commonPrinter';
import { FinishedProductModel } from '../../../../@models/erp/finishedProduct';
import { CookieService } from 'ngx-cookie';
import { AuthGuardService } from '../../../../@core/service/auth-guard.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { CacheType, CompilationModel, EPackingStatus, OfferData, ProjectRemark } from '../../../../@models/erp/compilation';
import { NbDialogService, NbPopoverComponent, NbPopoverDirective, NbToastrService } from '@nebular/theme';
import * as moment from 'moment';
import { distinctFromObjectArray, mongoId, round, waitForVariable } from '../../../../@core/common/global';
import { DocumentPrinterComponent } from '../../document/document-printer/document-printer.component';
import { ReportDatesComponent } from '../../document/report-dates/report-dates.component';
import { TreeService } from '../../../../@core/service/tree.service';
import { PopupDocumentComponent } from '../../document/document-printer/popup-document/popup-document.component';
import { WarehousingModel } from '../../../../@models/warehousing';
import { NrkWindowComponent } from '../../shared/nrk-window/nrk-window.component';
import { InternalUpdatesComponent } from './internal-updates/internal-updates.component';
import { EMessagingWindowMode, MessagingComponent } from '../../../warehousing/messaging/messaging.component';
import { catchError, firstValueFrom, Subject, takeUntil } from 'rxjs';
import * as ExcelJS from 'exceljs';
import * as saveAs from 'file-saver';
import { CommonDialogComponent, NrkDialogType } from '../../shared/common-dialog/common-dialog.component';
import { ProfitMarginComponent, ProfitMarginType } from '../../document/payment-plan/profit-margin/profit-margin.component';
import { SpoBoxModel } from '../../../../@models/erp/spoBox';
import { CacheInterceptor } from '../../../../@core/interceptors/cache.interceptor';


export interface IPopupReport {
  report: string,
  docs: CompilationModel[];
  reportData: any;
}

@Component({
  selector: 'ngx-reports-printer',
  templateUrl: './reports-printer.component.html',
  styleUrls: ['./reports-printer.component.css'],
})
export class ReportsPrinterComponent extends CommonPrinter implements OnInit, OnChanges, DoCheck {

  @Input() compilation: CompilationModel;
  @Input() search: any;
  @Input() pdfSidebar: boolean;
  @Input() dashboard: boolean = false;
  // @Input() users: UserModel[];
  // @Input() businesses: BusinessModel[];
  // @Input() businessUnits: BusinessUnitModel[];
  @Input() showButtons = false;
  @Input() printCount = false;
  @Input() isPopup = false;
  @Input() warehousing = false;
  @Input() messaging = false;
  @Input() warehousingPopup = false;
  @Input() warehousingData = {} as any;
  @Input() noheader = false;
  @Input() dnStati: any;
  @Input() silent = false;
  @Input() extraTitle = '';
  @Input() reverse = false;
  // @Input() dataOverride: { pdfData: any[], xlsData: any[] } = null;
  @Output() done = new EventEmitter<any>(); // returns search params and pdf data { params: any, pdfData: any }
  @Output() docCodes = new EventEmitter<string[]>(); // codes of currently visible items
  @Output() back = new EventEmitter<void>();
  @Output() popupReport = new EventEmitter<IPopupReport>()
  @Output() scroll = new EventEmitter<any>()

  @ViewChild('documentPrinter') documentPrinter: DocumentPrinterComponent;
  @ViewChild('scrollbox') scrollbox: ElementRef<HTMLElement>;
  @ViewChild('container') container: ElementRef<HTMLElement>;
  @ViewChild('popupDocument') popupDocument: PopupDocumentComponent;
  @ViewChild('messageWindow') messageWindow: MessagingComponent;
  @ViewChild('offerSettingsWindow') offerSettingsWindow: NrkWindowComponent;
  @ViewChild('removeSpoWindow') removeSpoWindow: NrkWindowComponent;
  @ViewChild('profitMarginWin') profitMarginWin: NrkWindowComponent;
  @ViewChild('internalUpdates') internalUpdates: InternalUpdatesComponent;
  @ViewChild('docEditor') docEditor: NrkWindowComponent;
  @ViewChild('docEditorReportDates') docEditorReportDates: ReportDatesComponent;
  @ViewChildren('profitMargin') profitMargins: QueryList<ProfitMarginComponent>;
  
  pdfData: any;
  xlsData: any;
  totalCount: number;
  headerText: string;
  csmap: any;

  showDocumentPreview = false;
  showDocumentPreviewHidden = false;
  showPopupDocument = false;

  deliveryConditionOptions = DeliveryConditionsData.getOptions();
  taxHintOptions = TaxHintData.getOptions();
  relatedDocuments = [];

  dueInfoData: any = [];
  currentDueInfoCode: string = '';

  dueInfoPopupData: any = [];

  currentMessage: WarehousingModel;

  currentOffer: CompilationModel = null;
  actionPointOptions = ActionPointData.getOptions();
  offerStatusOptions = OfferStatusData.getOptions();
  offerFields = DocConfig.getArray()
    .filter(f => f.value['offerField'] === true);
  percentOptions = [0,10,20,30,40,50,60,70,80,90,100].map(m => ({id: m, name: m+'%'}))
  statusCommentOptions = OfferStatusData.getOptions(1);
  

  profitMarginDocs?: CompilationModel[];

  protected offerStatus = OfferStatusData;

  // hideDispatched = false;
  // hideDelivered = true;

  packingStatus = EPackingStatus;
  messagingMode = EMessagingWindowMode;
  typeData = CompilationTypeData;
  fiscalYearOptions = FiscalYearData.getOptions();
  profitMarginType = ProfitMarginType;

  xlsPage = 0;
  
  xlsTables = {
    offers: [
      { name: 'documentNumber',  header: 'Offer' },
      { name: 'share', header: 'Share', extended: true },
      { name: 'issuer',  header: 'Issuer' },
      { name: 'issueDate',  header: 'Issue Date' },
      { name: 'offerValidity',  header: 'Offer Validity' },
      { name: 'businessUnit', header: 'BU' },
      { name: 'recipient',  header: 'Recipient' },
      // { name: 'vieDispatchDate',  header: 'delivery date' },
      // { name: 'customerReqDate',  header: 'customer date' },
      { name: 'accountManager',  header: 'Account Manager' },
      { name: 'documentStatus',  header: 'Document Status', extended: true },
      { name: 'rfqReference', header: 'RFQ Reference' },
      { name: 'rfqDate', header: 'RFQ Date' },
      { name: 'customerDocumentNumber',  header: 'Customer PO#' },
      { name: 'customerDocumentDate', header: 'Customer Date' },
      { name: 'baseProducts', header: 'Base Products', notextended: true },
      { name: 'baseProductsNet', header: 'Total NET by Base Products', align: 'right', type: 'price', notextended: true},
      // { name: 'quantityM2', header: 'QTY/m²', align: 'right', notextended: true },
      // { name: 'priceM2', header: 'Price/m²', align: 'right', notextended: true },
      { name: 'hasOrder', header: 'Order' },
      { name: 'fpCode',  header: 'Product Code', extended: true },
      { name: 'fpName',  header: 'Product Name', extended: true },
      { name: 'fpDimensions',  header: 'Dimensions', extended: true },
      // { name: 'lineItems.productName',  header: 'product name' },
      // { name: 'lineItems.quantity',  header: 'Pieces', align: 'right', extended: true },
      // { name: 'lineItems.piecePrice',  header: 'Piece Price', align: 'right', extended: true },
      // { name: 'lineItems.displayUnitQuantity',  header: 'Quantity', align: 'right', extended: true },
      // { name: 'lineItems.unit',  header: 'Unit', extended: true },
      // { name: 'lineItems.price',  header: 'Unit Price', align: 'right', extended: true },
      { name: 'lineItems.qpc',  header: 'Quantity/pc', align: 'right', extended: true },
      { name: 'lineItems.ppc',  header: 'Price/pc', align: 'right', extended: true },
      { name: 'lineItems.qm2',  header: 'Quantity/m²', align: 'right', extended: true },
      { name: 'lineItems.pm2',  header: 'Price/m²', align: 'right', extended: true },
      { name: 'lineItems.qm',  header: 'Quantity/m', align: 'right', extended: true },
      { name: 'lineItems.pm',  header: 'Price/m', align: 'right', extended: true },
      { name: 'lineItems.qkg',  header: 'Quantity/kg', align: 'right', extended: true },
      { name: 'lineItems.pkg',  header: 'Price/kg', align: 'right', extended: true },
      { name: 'lineItems.net',  header: 'Net Price', align: 'right', extended: true },
      { name: 'actionPoint', header: 'Action Point', extended: true },
      { name: 'offerStatus', header: 'Offer Status', extended: true },
      { name: 'statusComment', header: 'Status Comment', extended: true },
      { name: 'offerComment', header: 'Offer Comment', extended: true },
      { name: 'probability', header: 'Probability', extended: true },
      { name: 'share', header: 'Share', extended: true },
      { name: 'updatedAt', header: 'Updated', extended: true },
    ],
    orders: [
      { name: 'customerDocumentDate', header: 'PO Date' },
      { name: 'country', header: 'Country' },
      { name: 'recipient', header: 'Recipient' },
      { name: 'code', header: 'OR #' },
      { name: 'customerDocumentNumber', header: 'Customer Document #' },
      { name: 'customerReference', header: 'Customer Reference' },
      { name: 'businessUnit', header: 'Business Unit' },
      { name: 'baseProduct', header: 'Base Product' },
      { name: 'internal', header: 'Inrternal' },
      { name: 'supplierReference', header: 'Supplier Reference'},
      { name: 'fiscalYear', header: 'Fiscal Year' },
      { name: 'sumNet', header: 'Sum Net' },
      { name: 'currency', header: 'Currency' },
      { name: 'allInvoiced', header: 'All OCs Completely Invoiced' },
      { name: 'manualCompleted', header: 'Manual Completed' },
      // { name: 'projectCompleted', header: 'Invoiced or Manually Completed' },
    ],
    noninvoiced: [
      { name: 'documentNumber',  header: 'order confirmation' },
      { name: 'issuer',  header: 'issuer' },
      { name: 'issueDate',  header: 'issue date' },
      { name: 'recipient',  header: 'recipient' },
      { name: 'vieDispatchDate',  header: 'dispatch date' },
      { name: 'etaCustomer',  header: 'eta customer date' },
      { name: 'expectedNextInvoiceDate', header: 'expected next invoice date' },
      { name: 'customerReqDate',  header: 'requested date' },
      { name: 'customerAccDate',  header: 'accepted date' },
      { name: 'accountManager',  header: 'account manager' },
      { name: 'documentStatus',  header: 'document status' },
      { name: 'customerDocumentNumber',  header: 'customer document' },
      { name: 'customerDocumentDate', header: 'Customer Date' },
      { name: 'dispatchDateUnconfirmed',  header: 'NC' },
      { name: 'dnCode', header: 'delivery note' },
      { name: 'dnStatus', header: 'packing status'},
      { name: 'lineItems.trial', header: 'trial' },
      { name: 'calcCode',  header: 'product code' },
      { name: 'calcName',  header: 'product name' },
      { name: 'lineItems.quantity',  header: 'pieces', align: 'right' },
      { name: 'externalCode', header: 'external code' },
      { name: 'lineItems.piecePrice',  header: 'piece price', align: 'right', type: 'price' },
      { name: 'lineItems.displayUnitQuantity',  header: 'quantity', align: 'right' },
      { name: 'lineItems.unit',  header: 'unit', align: 'left' },
      { name: 'lineItems.price',  header: 'unit price', align: 'right', type: 'price' },
      { name: 'lineItems.net',  header: 'net price', align: 'right', type: 'price' },
    ],
    deliverynotes : [], // same as noninvoiced
    deliveryStatus: [
      { name: 'srStatus', header: 'SR Status', special: 1 },
      { name: 'recipient', header: 'Recipient', special: 2 },
      { name: 'customerDoc', header: 'Customer Document' },
      { name: 'customerDocumentDate', header: 'Customer Date' },
      { name: 'lineItems.li_popos', header: 'PO Pos' },
      { name: 'lineItems.partialDelivery', header: 'PD' },
      { name: 'documentNumber', header: 'OC #', special: 2 },
      { name: 'spoCodes', header: 'SPO #', special: 2},
      { name: 'vieDispatchDate', header: 'Dispatch Date' },
      { name: 'etaCustomer', header: 'ETA Customer' },
      { name: 'customerReqDate', header: 'CRDD', special: 2 },
      { name: 'exwDate', header: 'Actual EXW Date', special: 1 },
      { name: 'etaMinusRequested', header: 'ETA - CRDD' },
      { name: 'customerAccDate', header: 'Accepted Delivery Date' },
      { name: 'accountManager', header: 'accountManager', special: 2 },
      { name: 'fpCode', header: 'Product Code' },
      { name: 'fpName', header: 'Product Name', special: 2 },
      { name: 'trial', header: 'RX-Number', special: 1 },
      { name: 'fpDimensions', header: 'Product Dimensions', special: 2 },
      { name: 'externalCode', header: 'External Code' },
      { name: 'lineItems.quantity', header: 'Pieces', special: 2 },
      { name: 'lineItems.displayUnitQuantity', header: 'Quantity', special: 2 },
      { name: 'lineItems.unit', header: 'Unit', special: 2 },
      { name: 'messageText', header: 'Messages', special: 1 },
    ],
    projectoverview: [
      { name: 'issuer', header: 'Issuer' },
      { name: 'projectCompleted', header: 'Project Complete (manual)' },
      { name: 'complete', header: 'Project Complete (automatic)' },
      { name: 'openValue', header: 'No Remaining OC Value' },
      { name: 'invoicesPaid', header: 'All OC paid' },
      { name: 'spoOpenValue', header: 'No Remaining SPO Value' },
      { name: 'recipient', header: 'Company Name' },
      { name: 'customerDocumentNumber', header: 'PO Number' },
      { name: 'internal', header: 'Project Number' },
      { name: 'documentNumber', header: 'OC' },
      { name: 'baseProduct', header: 'Base Product Name' },
      { name: 'businessUnit', header: 'Factory' },
      { name: 'nextMilestone', header: 'Next Invoice Milestone' },
      { name: 'expectedNextInvoiceDate', header: 'Next Invoice Date', format: 'date' },
          // doc.customerDocumentDate = oc.customerDocumentDate;
          // doc.dateOfFAT = oc.dateOfFAT;
          // doc.exwDate = oc.exwDate;
          // doc.etaDate = oc.dateOfVieArrival;
          // doc.dateOfSAT = oc.dateOfSAT;
      { name: 'customerDocumentDate', header: 'PO Date' },
      { name: 'dateOfDrawings', header: 'Engineering Drawings Date' },
      { name: 'dateOfSourcing', header: 'Part Sourcing Date' },
      { name: 'dateOfFAT', header: 'FAT Date' },
      { name: 'exwDate', header: 'EXW Date' },
      { name: 'etaDate', header: 'ETA Date' },
      { name: 'dateOfSAT', header: 'SAT Date' },
      { name: 'endOfWarranty', header: 'End of Warranty' },
      // { name: 'internalUpdates', header: 'Current Info Requested From MM' },
      // { name: '', header: 'MM Comment / Update' },
    ],
    openspo: [
      { name: 'documentNumber', header : 'Document ID'},
      { name: 'recipient', header: 'Recipient', notextended: true },
      { name: 'customerReference', header: 'Customer', extended: true, timeline: true },
      { name: 'meansOfTransport', header: 'Transport Method'},
      { name: 'placeOfLoading', header: 'Place of Loading'},
      { name: 'firstIssueDate', header: 'Date of First Issue', extended2: true },
      { name: 'issueDate', header: 'Issue Date', format: 'date', extended2: true },
      { name: 'firstExwDate', header: 'First EXW Date', extended2: true },
      { name: 'dateOfPickup', header: 'Date of Pickup', format: 'date', notextended: true },
      { name: 'exwDate', header: 'EXW Date', format: 'date' },
      { name: 'arrivalDate', header: 'ETA AT Date', format: 'date' },
      { name: 'vieDispatchDate', header: 'Dispatch Date', format: 'date', extended: true },
      { name: 'etaCustomer', header: 'ETA Customer', format: 'date', extended: true },
      { name: 'customerAccDate', header: 'Accepted ETA Customer', format: 'date', extended2: true, timeline: true },
      { name: 'customerReqDate', header: 'Requested ETA Customer', format: 'date', extended: true, timeline: true },
      { name: 'customerDocumentNumber', header: 'Customer PO', extended: true, timeline: true },
      { name: 'relatedCS', header: 'Combined Shipment ID', extended: true, href: true },
      { name: 'transportStatus', header: 'Transport Status', notextended: true },
      { name: 'spoStatus', header: 'SPO Status', notextended: true },
      { name: 'availabilityStatus', header: 'Availability Status', notextended: true },
      { name: 'sampleRequest', header: 'SR', notextended: true },
      { name: 'fpCustomerCode', header: 'Customer Code', extended: true },
      { name: 'fpCode',  header: 'Product Code' },
      { name: 'fpName',  header: 'Product Name' },
      { name: 'fpDimensions',  header: 'Dimensions' },
      { name: 'lineItems.trial', header: 'Trial', timeline: true, notextended: true },
      // { name: 'lineItems.productName', header: 'product name'},
      { name: 'lineItems.displayUnitQuantity', header: 'QTY/Unit', align: 'right'},
      { name: 'lineItems.unit', header: 'Unit'},
      { name: 'lineItems.price', header: 'Price/Unit', align: 'right', type: 'price', notextended: true },
      { name: 'lineItems.quantityM', header: 'QTY/lm', align: 'right', extended: true },
      { name: 'lineItems.quantityM2', header: 'QTY/m²', align: 'right', extended: true },
      { name: 'lineItems.priceM2', header: 'Price/m²', align: 'right', extended2: true, type: 'price' },
      { name: 'currency', header: 'Currency', align: 'center', extended2: true, type: 'price' },
      { name: 'lineItems.net', header: 'Price', align: 'right', type: 'price', notextended: true },
      { name: 'lineItems.priceEUR', header: 'Buying Price (EUR)' , align: 'right', extended2: true, type: 'price' },
      { name: 'lineItems.priceM2EUR', header: 'Buying Price/m2 (EUR)' , align: 'right', extended2: true, type: 'price'  },
      { name: 'lineItems.netEUR', header: 'Buying Price NET (EUR)' , align: 'right', extended2: true, type: 'price'  },
      { name: 'lineItems.relatedOCs', header: 'Related OCs' , align: '', extended2: true  },
      { name: 'lineItems.sellPriceEUR', header: 'Selling Price (EUR)' , align: 'right', extended2: true, type: 'price'  },
      { name: 'lineItems.sellPriceM2EUR', header: 'Selling Price/m2 (EUR)' , align: 'right', extended2: true, type: 'price'  },
      { name: 'lineItems.sellPriceNetEUR', header: 'Selling Price net (EUR)' , align: 'right', extended2: true, type: 'price'  },
      { name: 'lineItems.markupEUR', header: 'Markup (EUR)' , align: 'right', extended2: true, type: 'price'  },
      { name: 'lineItems.markupPercent', header: 'Markup (%)' , align: 'right', extended2: true, type: 'price'  },
      // { name: 'lineItems.deliveryDate', header: 'delivery date'},
      { name: 'lineItems.palletQty', header: 'Pallet QTY', align: 'right', timeline: true },
      { name: 'lineItems.obic', header: 'OBIC ID' },
      { name: 'lineItems.partialDelivery', header: 'PD' },
      { name: '', header: 'Confirmed QTY/pc', format: 'int' },
      { name: '', header: 'Confirmed EXW Date', format: 'date' },
      { name: '', header: 'Factory Comment' },
    ],
    cs: [
      { name: 'documentNumber', header : 'CS Number'},
      { name: 'recipient', header : 'Recipient'},
      { name: 'placeOfLoading', header : 'Place of Loading'},
      { name: 'placeOfDelivery', header : 'Place of Delivery'},
      { name: 'meansOfTransport', header : 'Transport Method'},
      { name: 'exwJapanDate', header : 'EXW Date'},
      { name: 'arrivingVieDate', header : 'ETA VIE Date'},
      { name: 'transportStatus', header : 'Status'},
      { name: 'awbBlNr', header : 'AWB/BL Number'},
      { name: 'contNr', header : 'CONT Number'},
      { name: 'supplierIN', header : 'SupplierInvoice'},
      { name: '', header : 'Freight Forwarder'},
    ],
    invoiced: [
      { name: 'issueDate', header: 'issueDate', format: 'date' },
      { name: 'accountManager', header: 'accountManager' },
      { name: 'country', header: 'country' },
      { name: 'companyName', header: 'companyName' },
      { name: 'businessUnit', header: 'businessUnit' },
      { name: 'manufacturer', header: 'manufacturer' },
      { name: 'sampleRequest', header: 'sampleRequest' },
      { name: 'trialNumber', header: 'trialNumber' },
      { name: 'productCode', header: 'productCode' },
      { name: 'productName', header: 'productName' },
      { name: 'dimensions', header: 'dimensions' },
      { name: 'quantity', header: 'quantity in pc.', align: 'right'},
      { name: 'displayUnitQuantity', header: 'displayUnitQuantity', align: 'right' },
      { name: 'displayUnit', header: 'displayUnit' },
      { name: 'displayUnitPrice', header: 'displayUnitPrice', align: 'right' },
      { name: 'quantityM2', header: 'quantity in m²', align: 'right' },
      { name: 'priceM2', header: 'price/m²', align: 'right' },
      { name: 'totalPrice', header: 'totalPrice', align: 'right' },
      // { name: 'deliveryConditions', header: 'deliveryConditions' },
      { name: 'deliveryConditionsStr', header: 'deliveryConditions' },
      { name: 'type', header: 'type' },
      { name: 'issuer', header: 'issuer' },
      { name: 'customerDocumentNumber', header: 'customerDocumentNumber' },
      { name: 'documentNumber', header: 'documentNumber' },
      { name: 'lineItemPosition', header: 'lineItemPosition' },
      // { name: 'productName', header: 'productName' },
      // { name: 'originalOrderPosition', header: 'originalOrderPosition' },
      { name: 'paymentStatus', header: 'paymentStatus' },
      { name: 'documentStatus', header: 'documentStatus' },
      { name: 'dueDate', header: 'dueDate' },
      { name: 'nextPaymentDate', header: 'nextPaymentDate' },
      { name: 'paymentDate', header: 'paymentDate' },
      { name: 'fiscalYear', header: 'fiscalYear' },
      { name: 'vieDispatchDate', header: 'vieDispatchDate'},
      { name: 'etaCustomer', header: 'etaCustomerDate' },
      { name: 'customerReqDate', header: 'customerRequestedDeliveryDate'},
      { name: 'customerAccDate', header: 'customerAcceptedDeliveryDate'},
      { name: 'actualDeliveryDate', header: 'actualDeliveryDate'},
      // { name: 'quantity', header: 'quantity', align: 'right' },
      // { name: 'piecePrice', header: 'piecePrice', align: 'right' },
      // { name: 'core', header: 'core' },
      { name: 'connSpoCode', header: 'ConPFSPO' , align: '' },
      { name: 'connSpoCurrency', header: 'PFSPO currency' , align: '' },
      { name: 'connSpoPriceM2', header: 'OrigBuyingprice/m2' , align: '' },
      { name: 'connSpoTotalPrice', header: 'OrigBuyingprice' , align: '' },
      { name: 'connSpoPriceM2EUR', header: 'buyingprice/m2 (EUR)' , align: '' },
      { name: 'connSpoPriceEUR', header: 'Buying Price (EUR)' , align: '' },
      { name: 'connSpoMarkup', header: 'Markup (EUR)' , align: '' },
      { name: 'connSpoMarkupPercent', header: 'Markup %' , align: '' },
    ],
    openorders: [
      { name: 'vieDispatchDate', header: 'vieDispatchDate', format: 'date' },
      { name: 'accountManager', header: 'accountManager' },
      { name: 'country', header: 'country' },
      { name: 'companyName', header: 'companyName' },
      { name: 'businessUnit', header: 'businessUnit' },
      { name: 'sampleRequest', header: 'sampleRequest' },
      { name: 'trialNumber', header: 'trialNumber' },
      { name: 'productCode', header: 'productCode' },
      { name: 'productName', header: 'productName' },
      { name: 'dimensions', header: 'dimensions' },
      { name: 'displayUnitQuantity', header: 'displayUnitQuantity', align: 'right' },
      { name: 'displayUnit', header: 'displayUnit' },
      { name: 'displayUnitPrice', header: 'displayUnitPrice', align: 'right' },
      { name: 'quantityM2', header: 'quantity in m²', align: 'right' },
      { name: 'priceM2', header: 'price/m²', align: 'right' },
      { name: 'totalPrice', header: 'totalPrice', align: 'right' },
      // { name: 'deliveryConditions', header: 'deliveryConditions' },
      { name: 'deliveryConditionsStr', header: 'deliveryConditions' },
      { name: 'type', header: 'type' },
      { name: 'issuer', header: 'issuer' },
      { name: 'customerDocumentNumber', header: 'customerDocumentNumber' },
      { name: 'documentNumber', header: 'documentNumber' },
      { name: 'lineItemPosition', header: 'lineItemPosition' },
      // { name: 'productName', header: 'productName' },
      // { name: 'originalOrderPosition', header: 'originalOrderPosition' },
      { name: 'dueDate', header: 'dueDate' },
      { name: 'paymentStatus', header: 'paymentStatus' },
      { name: 'documentStatus', header: 'documentStatus' },
      { name: 'customerReqDate', header: 'customerRequestedDeliveryDate'},
      { name: 'actualDeliveryDate', header: 'actualDeliveryDate'},
      // { name: 'issueDate', header: 'issueDate' },
      // { name: 'quantity', header: 'quantity', align: 'right' },
      // { name: 'piecePrice', header: 'piecePrice', align: 'right' },
      // { name: 'core', header: 'core' },
      { name: 'connSpoCode', header: 'ConPFSPO' , align: '' },
      { name: 'connSpoCurrency', header: 'PFSPO currency' , align: '' },
      { name: 'connSpoPriceM2', header: 'OrigBuyingprice/m2' , align: '' },
      { name: 'connSpoTotalPrice', header: 'OrigBuyingprice' , align: '' },
      { name: 'connSpoPriceM2EUR', header: 'buyingprice/m2 (EUR)' , align: '' },
      { name: 'connSpoPriceEUR', header: 'Buying Price (EUR)' , align: '' },
      { name: 'connSpoMarkup', header: 'Markup (EUR)' , align: '' },
      { name: 'connSpoMarkupPercent', header: 'Markup %' , align: '' },
    ],
    invoicedandopenorders: [
      { name: 'issueDate', header: 'issueDate', format: 'date' },
      { name: 'accountManager', header: 'accountManager' },
      { name: 'country', header: 'country' },
      { name: 'companyName', header: 'companyName', extended: 1 },
      { name: 'businessUnit', header: 'businessUnit' },
      { name: 'manufacturer', header: 'manufacturer' },
      { name: 'sampleRequest', header: 'sampleRequest' },
      { name: 'trialNumber', header: 'trialNumber' },
      { name: 'productCode', header: 'productCode', extended: 1 },
      { name: 'productName', header: 'productName'},
      { name: 'dimensions', header: 'dimensions'},
      { name: 'quantity', header: 'quantity in pc.', align: 'right'},
      { name: 'quantityM2', header: 'quantity in m²', align: 'right' },
      { name: 'quantityLM', header: 'quantity in LM', align: 'right' },
      { name: 'quantityKg', header: 'quantity in kg', align: 'right' },
      { name: 'pricePc', header: 'price/pc', align: 'right' },
      { name: 'priceM2', header: 'price/m²', align: 'right' },
      { name: 'priceLM', header: 'price/LM', align: 'right' },
      { name: 'priceKg', header: 'price/kg', align: 'right' },
      { name: 'totalPrice', header: 'totalPrice', align: 'right' },
      { name: 'deliveryConditionsStr', header: 'deliveryConditions' },
      { name: 'type', header: 'type' },
      { name: 'issuer', header: 'issuer' },
      { name: 'customerDocumentNumber', header: 'customerDocumentNumber' },
      { name: 'documentNumber', header: 'documentNumber' },
      { name: 'lineItemPosition', header: 'lineItemPosition' },
      { name: 'paymentStatus', header: 'paymentStatus' },
      { name: 'documentStatus', header: 'documentStatus' },
      { name: 'dueDate', header: 'dueDate' },
      { name: 'nextPaymentDate', header: 'nextPaymentDate' },
      { name: 'paymentDate', header: 'paymentDate' },
      { name: 'fiscalYear', header: 'fiscalYear' },
      { name: 'vieDispatchDate', header: 'vieDispatchDate'},
      { name: 'etaCustomerDate', header: 'etaCustomerDate' },
      { name: 'customerReqDate', header: 'customerRequestedDeliveryDate'},
      { name: 'customerAccDate', header: 'customerAcceptedDeliveryDate'},
      { name: 'actualDeliveryDate', header: 'actualDeliveryDate'},
      { name: 'connSpoCode', header: 'ConPFSPO' , align: '' },
      { name: 'connSpoCurrency', header: 'PFSPO currency' , align: '' },
      { name: 'connSpoPriceM2', header: 'OrigBuyingprice/m2' , align: '' },
      { name: 'connSpoTotalPrice', header: 'OrigBuyingprice' , align: '' },
      { name: 'connSpoPriceM2EUR', header: 'buyingprice/m2 (EUR)' , align: '' },
      { name: 'connSpoPriceEUR', header: 'Buying Price (EUR)' , align: '' },
      { name: 'connSpoMarkup', header: 'Markup (EUR)' , align: '' },
      { name: 'connSpoMarkupPercent', header: 'Markup %' , align: '' },
    ],
    pricematrix: [
      { name: 'accounting', header: 'Price type' },
      { name: 'issuer', header: 'Issuer', extended: true },
      { name: 'accountManager', header: 'Area sales manager' },
      { name: 'country',header: 'Country' },
      { name: 'customer', header: 'Customer' },
      { name: 'businessUnit', header: 'Business Unit'},
      { name: 'productCode', header: 'Product Code' },
      { name: 'calculatedName', header: 'Product Name' },
      { name: 'pmdims', header: 'Dimensions' },
      { name: 'trialNumber', header: 'Trial Number' },
      { name: 'fpCustomers', header: 'Product Customer(s)', extended: true },
      { name: 'customerProductName', header: 'Customer Product Name' },
      // { name: 'perM', header: '€/m' },
      // { name: 'per100m', header: '€/100m' },
      // { name: 'perUnit', header: '€/unit' },
      // { name: 'perRoll', header: '€/roll' },
      // { name: 'perKg', header: '€/kg' },
      // { name: 'perSqM', header: '€/m²' },
      { name: 'value', header: 'Price/Unit', align: 'right', extended: true },
      { name: 'displayUnit', header: 'Unit', align: 'center', extended: true },
      { name: 'pricePc', header: 'Price per Piece', align: 'right' },
      { name: 'priceM2', header: 'Price in m²', align: 'right' },
      { name: 'priceLm', header: 'Price in LM', align: 'right' },
      { name: 'currency', header: 'Currency', align: 'center' },
      { name: 'priceDate', header: 'Price Date' },
      { name: 'validFrom', header: 'Valid From' },
      { name: 'validTo', header: 'Valid To' },
      // { name: 'materialOuterSide', header: 'materialOuterSide' },
      // // { name: 'coreLabelling', header: 'coreLabelling' },
      // { name: 'packing', header: 'packing' },
      // { name: 'rolesPerBox', header: 'roles/box' },
      { name: 'totalAreaWeight', header: 'Area Weigth', align: 'right', extended: true },
      { name: 'dimWidth', header: 'Width', align: 'right', extended: true },
      { name: 'dimRollLength', header: 'Roll Length', align: 'right', extended: true },
      { name: 'piecesPerCarton', header: 'Rolls per Carton Box', align: 'right', extended: true },
      { name: 'fpStatus', header: 'FP Status' },
    ],
    dueinvoices: [
      { name: 'code', hidden: true },
      { name: 'version', hidden: true },
      { name: 'issuer', header: 'Issuer' },
      { name: 'documentNumber', header: 'Document #' },
      { name: 'recipient', header: 'Recipient' },
      { name: 'issueDate', header: 'Issue Date' },
      { name: 'dueDate', header: 'Due Date' },
      { name: 'fiscalYear', header: 'Fiscal Year' },
      { name: 'nextPaymentDate', header: 'Next IN Due Date', editable: true, date: true },
      { name: 'dueText', header: 'Due Info', editable: true, dueInfo: true, style: {width:'40em'} },
      { name: 'dueOverdue', header: 'Due Status' },
      { name: 'lastDueUpdate', header: 'Last Due Update' },
      { name: 'vieDispatchDate', header: 'Dispatch Date' },
      { name: 'etaCustomer', header: 'ETA Customer' },
      { name: 'customerReqDate', header: 'CRDD' },
      { name: 'customerAccDate', header: 'CADD' },
      { name: 'issuedBy', header: 'User' },
      { name: 'accountManager', header: 'Account Manager' },
      { name: 'customerDocumentNumber', header: 'Customer Reference' },
      { name: 'totalPrice', header: 'Sum NET', align: 'right' },
      { name: 'currency', header: 'Currency', align: 'center' },
    ],
    lastinvoices: [
      { name: 'paymentStatus', header: 'Payment Status', extended: 2 },
      { name: 'issueDate', header: 'Issue Date' },
      { name: 'country', header: 'Country' },
      { name: 'recipient', header: 'Recipient' },
      { name: 'documentNumber', header: 'INV #' },
      { name: 'customerDocumentNumber', header: 'Customer Reference' },
      { name: 'businessUnits', header: 'Business Unit'},
      { name: 'internal', header: 'Internal'},
      { name: 'supplierReference', header: 'Supplier Reference'},
      { name: 'fiscalYear', header: 'Fiscal Year' },
      { name: 'dueDate', header: 'Due Date' },
      { name: 'paymentDate', header: 'Payment Date' },
      { name: 'pmntDueDiff', header: 'Payment Date Minus Due Date' },
      { name: 'nextPaymentDate', header: 'Next IN Due Date' },
      { name: 'vieDispatchDate', header: 'Dispatch Date' },
      { name: 'etaCustomer', header: 'ETA Customer Date', extended: 1 },
      { name: 'customerReqDate', header: 'CRDD', extended: 1 },
      { name: 'customerAccDate', header: 'CADD', extended: 1 },
      { name: 'testCertificate', header: 'TC', extended: 1 },
      { name: 'proveOfDelivery', header: 'PoD', extended: 1 },
      { name: 'transactionReceipt', header: 'TR' },
      { name: 'net', header: 'Sum NET', align: 'right' },
      { name: 'currency', header: 'Currency', align: 'center' },
    ],
    baseProducts: [
      { name: 'name', header: 'Name' },
      { name: 'trial', header: 'Trial number (offer number)' },
      { name: 'businessUnit', header: 'BusinessUnit' },
      { name: 'material', header: 'Material' },
      { name: 'thickness', header: 'Thickness (µm)' },
      { name: 'status', header: 'Status' },
      { name: 'customer', header: 'Customer' },
      { name: 'supplier', header: 'Supplier' },
      { name: 'weight', header: 'Total area weight (g/m²)' },
      { name: 'binderContent', header: 'Binder content (g/m²)' },
      { name: 'accelType', header: 'Accelerator type' },
      { name: 'accelContent', header: 'Accelerator content (mg/m²)' },
      { name: 'micaPaper', header: 'Mica paper' },
      { name: 'grammatureMica', header: 'Grammature mica (g/m²)' },
      { name: 'shelfLife', header: 'Shelf life' },
      { name: 'remark', header: 'Remark' },
      { name: 'code', header: 'Code' },
      { name: 'version', header: 'Version' },
      { name: 'technicalDatasheets', header: 'TDS (Technical Datasheet)' },
      { name: 'files', header: 'Attached files' },
      { name: 'editCount', header: 'Edit count' },
      { name: 'owner', header: 'Issuer' },
      { name: 'disabled', header: 'Disabled' },

      { name: 'dateCreated', header: 'Date created' },
      { name: 'dateUpdated', header: 'Date updated' },
      { name: 'draft', header: 'Draft' },
      // { name: 'changelog', header: 'Changelog' },
      { name: 'shelfLife20Deg', header: 'Shelf life @ 20°C (months)' },
      { name: 'shelfLife10Deg', header: 'Shelf life @ 10°C (months)' },
      { name: 'shelfLife5Deg', header: 'Shelf life @ 5°C (months)' },
      { name: 'shelfLifeFromDispatch20Deg', header: 'Shelf life from dispatch @ 20°C (months)' },
      { name: 'shelfLifeFromDispatch10Deg', header: 'Shelf life from dispatch @ 10°C (months)' },
      { name: 'shelfLifeFromDispatch5Deg', header: 'Shelf life from dispatch @ 5°C (months)' },
      { name: 'shelfLifeMinInternal20Deg', header: 'Minimum internal shelf life @ 20°C (months)' },
      { name: 'shelfLifeMinInternal10Deg', header: 'Minimum internal shelf life @ 10°C (months)' },
      { name: 'shelfLifeMinInternal5Deg', header: 'Minimum internal shelf life @ 5°C (months)' }

    ],
    finishedProducts: [
      { name: 'product', header: 'Base Product' },
      { name: 'trial', header: 'Trial' },
      { name: 'type', header: 'Type' },
      { name: 'status', header: 'Status' },
      { name: 'customers', header: 'Customers' },
      { name: 'suppliers', header: 'Suppliers' },
      { name: 'calcName', header: 'Internal name' },
      { name: 'calcCode', header: 'Internal code' },
      { name: 'nameOverride', header: 'Name override' },
      { name: 'externalName', header: 'External name' },
      { name: 'externalCode', header: 'External code' },
      { name: 'publicRemark', header: 'Public remark' },
      { name: 'hs', header: 'HS code' },
      { name: 'machineryWeight', header: 'Net weight (kg)' },
      { name: 'core', header: 'Core' },
      { name: 'width', header: 'Width (mm)' },
      { name: 'rollLength', header: 'Roll length (m)' },
      { name: 'micaInOut', header: 'Mica in/out' },
      { name: 'finishedRollWindingStrength', header: 'Finished roll winding strength (N/cm)' },
      { name: 'jointTapeType', header: 'Joint adhesive tape type' },
      { name: 'jointTapeWidth', header: 'Joint adhesive tape width' },
      { name: 'jointMethod', header: 'Joint method' },
      { name: 'jointLocation', header: 'Joint location and number within the roll' },
      { name: 'jointsWithinQuantification', header: 'Allowed amount of joints' },
      { name: 'jointOtherRequirements', header: 'Other joint requirements' },
      { name: 'coreLabeling', header: 'Core labeling' },
      { name: 'insidePackingLabeling', header: 'Inside packing labeling' },
      { name: 'outsideCartonBoxLabeling', header: 'Outside carton box labeling' },
      { name: 'deliveryCollieLabeling', header: 'Delivery collie labeling' },
      { name: 'specifiedShelfLifeCondition', header: 'Specified Shelf life condition' },
      { name: 'requiredTestParameters', header: 'Required test parameters (Test certificate)' },
      { name: 'cartonSize', header: 'Carton size' },
      { name: 'piecesPerCarton', header: 'Number of pieces per carton box' },
      { name: 'remark', header: 'Remark' },
      { name: 'code', header: 'Code' },
      { name: 'version', header: 'Version' },
      { name: 'files', header: 'Attached files' },
      { name: 'editCount', header: 'Edit count' },
      { name: 'owner', header: 'Issuer' },
      { name: 'disabled', header: 'Disabled' },

      { name: 'allCustomers', header: 'All customers' },
      { name: 'allSuppliers', header: 'All suppliers' },
      { name: 'obic', header: 'OBIC' },
      { name: 'customerProductSpecification', header: 'Customer product specification' },
      { name: 'customerIdentificator', header: 'Customer identificator' },
      { name: 'showMissingCpsWarning', header: 'Show CPS warning' },
      { name: 'draft', header: 'Draft' },
      // { name: 'changelog', header: 'Changelog' },
      { name: 'packing', header: 'Packing' },
      { name: 'packingSpec', header: 'Packing specification' },
      { name: 'boxLabelPriority', header: 'Box label priority' }
    ],
    boxes: [
      { name: 'palletId', header: 'Pallet ID', align: 'center' },
      { name: 'boxId', header: 'Box ID', align: 'center' },
      { name: 'boxNr', header: 'Box #', align: 'center' },
      { name: 'lot', header: 'Lot #' },
      { name: 'quantity', header: 'Q', align: 'right' },
      { name: 'tc', header: 'TC #' },
      { name: 'boxType', header: 'Box Type', extended: 30 },
      { name: 'fpBoxType', header: 'FP Box Type', extended: 30 },
      { name: 'boxStatus', header: 'Box Status', extended: 30 },
      { name: 'prodDate', header: 'Prod Date' },
      { name: 'minProdDate', header: 'Oldest PD', extended: 20 },
      { name: 'maxProdDate', header: 'Newest PD', extended: 20 },
      { name: 'shelfLifeText', header: 'Shelf Life Text' },
      { name: 'shelfLifeDate', header: 'Shelf Life Date', extended: 20 },
      { name: 'shelfLifeDateOverride', header: 'Shelf Life Date Override', extended: 20 },
      { name: 'obic', header: 'OBIC', extended: 20 },
      { name: 'spo', header: 'PFSPO #', extended: 20 },
      { name: 'spoPos', header: 'PFSPO Pos', extended: 20 },
      { name: 'spoRecipient', header: 'PFSPO Recipient', extended: 20 },
      { name: 'spoCustomerReference', header: 'PFSPO Customer', extended: 10 },
      { name: 'spoCountry', header: 'PFSPO Country', extended: 20, hidden: true },
      { name: 'spoCalcCode', header: 'PFSPO Product #', extended: 20 },
      { name: 'spoCalcName', header: 'PFSPO Product Name', extended: 20 },
      { name: 'spoDimensions', header: 'PFSPO Product Dimensions', extended: 20 },
      { name: 'spoPiecePrice', header: 'PFSPO Price/Piece', align: 'right', extended: 10 },
      { name: 'spoBoxPrice', header: 'PFSPO Price/Box', align: 'right', extended: 10 },
      { name: 'spoCurrency', header: 'PFSPO Currency', extended: 10 },
      { name: 'exwDate', header: 'EXW Date', extended: 20 },
      { name: 'arrivalDate', header: 'ETA AT Date', extended: 20 },
      { name: 'spoPalNr', header: 'PFSPO Pallet #', extended: 20, align: 'center' },
      { name: 'dnCustomerDoc', header: 'Customer PO #' },
      { name: 'dnPartdel', header: 'PD X/Y', align: 'center' },
      { name: 'oc', header: 'OC #' },
      { name: 'dn', header: 'DN #' },
      { name: 'dnPos', header: 'DN/OC Pos' },
      { name: 'dnRecipient', header: 'DN/OC Customer' },
      { name: 'dnCountry', header: 'DN/OC Country', extended: 20, hidden: true },
      { name: 'dispatchDate', header: 'Dispatch Date' },
      { name: 'dnCalcCode', header: 'DN/OC Product #' },
      { name: 'dnCalcName', header: 'DN/OC Product Name', extended: 20 },
      { name: 'dnDimensions', header: 'DN/OC Product Dimensions' },
      { name: 'ocPiecePrice', header: 'OC Price/Piece', align: 'right', extended: 20 },
      { name: 'ocBoxPrice', header: 'OC Price/Box', extended: 20, align: 'right' },
      { name: 'dnPalNr', header: 'DN/OC Pallet #', extended: 20, align: 'center' },
      // { name: 'spoTransportStatus', header: 'Transport Status', extended: 20},
      { name: 'stockStatus', header: 'Box Stock Status', extended: 20 },
      // { name: 'placeOfLoading', header: 'Place of Loading', extended: 20 },
      { name: 'customerProductCode', header: 'Customer Product Code' },
      { name: 'customerProductName', header: 'Customer Product Name' },
    ],
    expiryreport: [ // inventory report with focus on expiry dates, used for internal inventory management
      { name: 'ocYesNo', header: 'OC', align: 'center' },
      // { name: 'shelfLifeDate', header: 'Internal Expiry Date at 5°C' },
      { name: 'expiryDateAt5Deg', header: 'Internal Expiry Date at 5°C' },
      { name: 'internalRemainingShelfLife', header: 'Internal Remaining Shelf Life in Months' },
      // { name: 'maxShelfLife', header: 'Remaining Max Shelf Life at Dispatch' },
      // { name: '', header: 'First Priority Box Label' },
      // { name: 'shelfLifeLt6', header: 'shelf Life < 6 Months', color: '#FF0000' },
      // { name: 'shelfLifeLt12', header: 'shelf Life < 12 Months', color: '#FFFF00' },
      // { name: 'reinspectionNeeded', header: 'Reinspection Needed', },
      // { name: 'remainingShelfLifePercent', header: 'Remaining Shelf Life %', },
      { name: 'shelfLifeDateExpiry', header: 'Shelf Life on Box Label' },
      { name: 'internalBoxLabelDiffDays', header: 'Internal Shelf Life - Shelf Life on Box Label (days)' },
      { name: 'firstPriorityText', header: 'Shelf Life Text' },
      { name: 'dispatchDate', header: 'Dispatch Date' },
      { name: 'prodDate', header: 'Prod Date' },
      { name: 'oc', header: 'OC' },
      { name: 'arrivalDate', header: 'ETA AT Date', enRoute: true },
      // { name: 'spoTransportStatus', header: 'Transport Status', enRoute: true },
      { name: 'spoTransportStatus', header: 'Transport Status'},
      { name: 'spo', header: '(PF)SPO #' },
      // { name: 'spoPos', header: '(PF)SPO Pos' },
      { name: 'spoCalcName', header: '(PF)SPO Product Name' },
      { name: 'spoDimensions', header: '(PF)SPO Product Dimensions' },
      { name: 'spoCustomerReference', header: '(PF)SPO Customer' },
      { name: 'spoSalesManager', header: 'Sales Manager' },
      { name: 'free/assigned', header: 'Free / Assigned Q', align: 'right' },
      { name: 'quantity', header: '∑ Q', align: 'right' },
      { name: 'quantityM2', header: '∑ Q (m²)', align: 'right' },
      { name: 'spoCurrency', header: '(PF)SPO Currency' },
      { name: 'spoBoxPrice', header: '∑ (PF)SPO Price/Box', align: 'right', format: 'currency' },
      { name: 'ocCurrency', header: 'OC Currency' },
      { name: 'ocBoxPrice', header: '∑ OC Price/Box', extended: true, align: 'right', format: 'currency' },
    ],
    expirywithenroute: [
      { name: 'fpCategory', header: 'Category' },
      { name: 'spoCalcCode', header: 'FP Product Code' },
      { name: 'spoCalcName', header: '(PF)SPO Product Name' },
      { name: 'spoDimensions', header: '(PF)SPO Product Dimensions' },
      { name: 'spoCustomerReference', header: '(PF)SPO Customer' },
      // { name: 'availabilityQ', header: 'Availability Q' },
      { name: 'freeQ', header: 'Free Q', align: 'right' },
      { name: 'assignedQ', header: 'Assigned Q', align: 'right' },
      // { name: 'deliveredQ', header: 'Delivered Q', align: 'right' },
      // { name: 'availableQ', header: 'Available Q', align: 'right' },
      { name: 'quantity', header: '∑ Q', align: 'right' },
      { name: 'quantityM2', header: '∑ Q (m²)', align: 'right' },
      { name: 'spoTransportStatus', header: 'Transport Status'},
      { name: 'spo', header: '(PF)SPO #' },
      { name: 'oc', header: 'OC' },
      { name: 'ocYesNo', header: 'OC', align: 'center' },
      { name: 'arrivalDate', header: 'ETA AT Date', enRoute: true },
      { name: 'dispatchDate', header: 'Dispatch Date' },
    ],
    spopayment: [
      { name: 'spInvoiceDate', header: 'SPIN Issue Date', },
      { name: 'spInvoice', header: 'SPIN #', },
      { name: 'spInvoiceValue', header: 'SPIN Net', format: 'currency' },
      { name: 'paymentDate', header: 'Payment Date' },
      { name: 'spInUploaded', header: 'IN Uploaded' },
      { name: 'spTrUploaded', header: 'TR Uploaded' },
      { name: 'projectCompleted', header: 'Manually Completed'},
      { name: 'spo', header: 'SPO #'},
      { name: 'recipient', header: 'SPO Recipient', },
      { name: 'customer', header: 'SPO Customer Name', },
      { name: 'customerDocumentNumber', header: 'SPO Customer Reference', },
      { name: 'internal', header: 'SPO Internal', },
      { name: 'supplierReference', header: 'SPO Quotation Reference', },
      { name: 'product', header: 'Product', },
      { name: 'fiscalYear', header: 'Financial Year', },
      { name: 'spInvoiceDateFiscalYear', header: 'SPIN Issue Date Year', },
      { name: 'fiscalYearEqualsSpFiscalYear', header: 'Financial Year = Issue Year', },
    ],
    inventory: [],
    inventoryMonthly: [
      { name: 'nrProdId', header: 'NR PROD ID' },
      { name: 'isSR', header: 'SR' },
      { name: 'customerProduct', header: 'CUSTOMER PROD ID' },
      { name: 'customer', header: 'CUSTOMER' },
      { name: 'lastMonthPc', header: 'Last Month PC' },
      { name: 'lastMonthPcSR', header: 'Last Month SR' },
      { name: 'inSpoPc', header: 'IN (PC)' },
      { name: 'inSpoPcSR', header: 'IN (SR)' },
      { name: '', header: 'IN (PC) COMMENTS NRJ' },
      { name: 'inPcObicCode', header: 'IN (OBIC/FACTORY ID)' },
      { name: 'cs', header: 'GS' },
      { name: 'csInvoices', header: 'IN (INVOICE ID)' },
      { name: 'outPcObicCode', header: 'OUT (OBIC/FACTORY ID)' },
      { name: 'outDN', header: 'OUT (DN)' },
      { name: 'outIN', header: 'OUT (IN)' },
      { name: 'outINPcCode', header: 'OUT (PC) / INVOICE' },
      { name: 'outPcTotal', header: 'OUT (PC) / TOTAL' },
      { name: 'outPcTotalSR', header: 'OUT / TOTAL (SR)' },
      { name: '', header: 'OUT (PC) / TOTAL COMMENTS NRJ' },
      { name: 'monthPc', header: 'ON STOCK PC' },
      { name: 'monthPcSR', header: 'ON STOCK PC (SR)' },
      { name: '', header: 'THIS MONTH PC COMMENTS NRJ' },
      { name: '', header: 'DAMAGED / EXP' },
      { name: '', header: 'COMMENTS NRA' },
      { name: '', header: 'COMMENTS NRJ' },
    ]
  }

  pdfTables = {
    default: {
      docTable: [
        { width: '7rem', name: 'documentNumber',         header: 'Document #', align: 'left', href: true },
        {                name: 'recipient',              header: 'Recipient', align: 'left' },
        { width: '4.3rem', name: 'issueDate',              header: 'Issue date',  align: 'center' },
        { width: '4.3rem', name: 'vieDispatchDate',        header: 'Dispatch date',  align: 'center' },
        { width: '4.3rem', name: 'customerReqDate',        header: 'Cust. req. date', align: 'center' },
        { width: '4.3rem', name: 'customerAccDate',        header: 'Cust. acc. date', align: 'center' },
        { width: '4.3rem', name: 'etaCustomer',        header: 'ETA customer', align: 'center' },
        { width: '8rem', name: 'accountManager',         header: 'Account manager', align: 'left' },
        { width: '8.5rem', name: 'customerDocumentNumber', header: 'Customer reference', align: 'left' },
      ],
      docTable2: null,
      productTable: [
        {                  name: 'lineItems.productName',        header: 'Product name' },
        { width: '3rem',   name: 'lineItems.quantity',           header: 'Pieces',      align: 'right' },
        { width: '4.5rem', name: 'lineItems.piecePrice',         header: 'Price/piece', align: 'right', price: true },
        { width: '3rem',   name: 'lineItems.displayUnitQuantity',header: 'Quantity',    align: 'right' },
        { width: '1.5rem', name: 'lineItems.unit',               header: 'Unit' },
        { width: '4.5rem', name: 'lineItems.price',              header: 'Price/unit',  align: 'right', price: true },
        { width: '5rem',   name: 'lineItems.net',                header: 'Net price',   align: 'right', price: true },
      ],
    },
    openspo: {
      docTable: [
        { width: '10rem', name: 'documentNumber',         header: 'Document number', align: 'left', href: true },
        { width: '9rem', name: 'recipient',         header: 'Supplier', align: 'left' },
        // { width: '4.5rem', name: 'issueDate',              header: 'Issue date',  align: 'center' },
        // { width: '4.5rem', name: 'exwDate',              header: 'EXW date',  align: 'center' },
        // { width: '4.5rem', name: 'arrivalDate',        header: 'Arrival date',  align: 'center' },
        // { width: '4.5rem', name: 'vieDispatchDate',        header: 'Dispatch date',  align: 'center' },
        // { width: '4.5rem', name: 'customerReqDate',        header: 'Customer requested date',  align: 'center' },
        { width: '5rem', name: 'transportStatus',        header: 'Transport status',  align: 'center' },
        { width: '14rem', name: 'customerReference',        header: 'Customer',  align: 'left' },
        {                name: 'customerDocumentNumber',        header: 'Customer reference',  align: 'left' },
        { width: '6rem', name: 'spoStatus',        header: '(PF)SPO status',  align: 'center' },
        { width: '6rem', name: 'availabilityStatus',        header: 'Availability',  align: 'center' },
        { width: '8rem', name: 'meansOfTransport',              header: 'Transportation', align: 'left' },
        { width: '8rem', name: 'relatedCS',        header: 'Combined shipment',  align: 'left', href: true },
      ],
      extra: {
        width: { table: '8rem', cols: [{header: '3.6rem', value: '4.2rem'}] },
        // table: [
        //   [{ name: 'issueDate',              header: 'Issue date',  align: 'center' },
        //     { name: 'vieDispatchDate',        header: 'Dispatch date',  align: 'center' },
        //   ],
        //   [{ name: 'exwDate',              header: 'EXW date',  align: 'center' },
        //     { name: 'customerReqDate',        header: 'Cust. req. date',  align: 'center' },
        //   ],
        //   [{ name: 'arrivalDate',        header: 'Arrival date',  align: 'center' },
        //   ],
        // ],
        table: [
          [{ name: 'readyForPickup', compare: 'dateOfPickup',             header: 'Pickup date',  align: 'center' }],
          [{ name: 'exwDate',        compare: 'dateOfEXW',      header: 'EXW date',  align: 'center' }],
          [{ name: 'arrivalDate',    compare: 'dateOfArrival',          header: 'ETA AT date',  align: 'center' }],
        ],
      },
      productTable: [
        {                  name: 'lineItems.productName',        header: 'Product name' },
        { width: '6rem',   name: 'lineItems.obic',           header: 'OBIC',      align: 'center' },
        { width: '2rem',   name: 'lineItems.li_partdel',              header: 'PD', align: 'center'}, // partial delivery
        { width: '3rem',   name: 'lineItems.quantity',           header: 'Pieces',      align: 'right' },
        { width: '3.5rem', name: 'lineItems.m2',               header: 'm²', align: 'right' },
        { width: '4.5rem',   name: 'lineItems.price',              header: 'Price/piece',  align: 'right', price: true },
        { width: '5rem',   name: 'lineItems.net',                header: 'Net price',   align: 'right', price: true },
        { width: '4.5rem',   name: 'lineItems.weight',             header: 'Net weight',   align: 'right' },
      ],
      productExtra: {
        table: [
          { width: '6.5rem',   name: 'lineItems.extra.calcName',              header: 'OC', href: true},
          // { width: '6.5rem',   name: 'lineItems.extra.code',              header: 'OC', href: true},
          { width: '4.3rem',   name: 'lineItems.extra.issueDate',           header: 'Issue dt',  align: 'center' },
          { width: '4.3rem',   name: 'lineItems.extra.vieDispatchDate',
            compare: 'lineItems.extra.dateOfDispatch',  header: 'Dispatch dt',  align: 'center' },
          { width: '4.3rem', name: 'lineItems.extra.customerRequestedDeliveryDate', header: 'CRDD', align: 'center' },
          { width: '4.3rem', name: 'lineItems.extra.customerAcceptedDeliveryDate', header: 'CADD', align: 'center' },
          { width: '4.3rem', name: 'lineItems.extra.etaCustomerDate', compare: 'lineItems.extra.dateOfDelivery', header: 'ETAC', align: 'center' },
          {                  name: 'lineItems.extra.customerName',           header: 'Customer' },
          { width: '15rem',   name: 'lineItems.extra.productName',           header: 'Product name' },
          { width: '6rem',   name: 'lineItems.extra.customerDocumentNumber',           header: 'Customer PO' },
          { width: '3.5rem',   name: 'lineItems.extra.quantity',           header: 'Quantity',  align: 'right' },
        ],
      },
    },
    lastinvoices: { docTable: null, docTable2: null, productTable: null, productExtra: null },
    orders: { docTable: null, docTable2: null, productTable: null, productExtra: null },
    noninvoiced: { docTable: null, docTable2: null, productTable: null, productExtra: null, additional: null },
    dueinvoices: { docTable: null, docTable2: null, productTable: null },
    offers: { docTable: null, productTable: null },
  }


  // loading: boolean;

  currentTable: any;
  // query: any; // -> this.search.{subobject from ReportsComponent::report}

  currentManager: string;

  transformScale = 1;
  dashboardTransformScale = 1.4;

  reportMargin = 0;

  finishedProductNames = 'All';

  relatedOrders: CompilationModel[] = [];

  getDateLineDocTable2(dispatch = true) {
    return [
      { label: { text: 'Issue Date:' }, data: { name: 'issueDate', align: 'center' }},
      { label: { text: 'Planned Nxt Inv Dt:' }, data: { name: 'expectedNextInvoiceDate', align: 'center' }},
      { label: { text: 'PO Date:' }, data: { name: 'customerDocumentDate', align: 'center' }},
      { label: { text: 'FAT date:' }, data: { name: 'dateOfFAT', align: 'center' }},
      dispatch
        ? { label: { text: 'Dispatch Dt:' }, data: { name: 'vieDispatchDate', align: 'center' }}
        : { label: { text: 'EXW Date:' }, data: { name: 'exwDate', align: 'center' }},
      { label: { text: 'CRDD:' }, data: { name: 'customerReqDate', field: 'customerRequestedDeliveryDate', align: 'center' }},
      { label: { text: 'CADD:' }, data: { name: 'customerAccDate', field: 'customerAcceptedDeliveryDate', align: 'center' }},
      { label: { text: 'ETA Date:' }, data: { name: 'etaCustomer', field: 'etaCustomerDate', align: 'center' }},
      { label: { text: 'SAT Date:' }, data: { name: 'dateOfSAT', align: 'center' }},
      { label: { text: 'EoW Date:' }, data: { name: 'endOfWarranty', align: 'center' }},
      { label: { text: 'EDR Date:' }, data: { name: 'dateOfDrawings', align: 'center' }},
      { label: { text: 'PS Date:' }, data: { name: 'dateOfSourcing', align: 'center' }},
      { label: { text: 'IN Due Date:' }, data: { name: 'dueDate', align: 'center' }},
      { label: { text: 'Nxt IN Due Dt:' }, data: { name: 'nextPaymentDate', align: 'center' }},
      { label: { text: 'Fiscal Year:' }, data: { name: 'fiscalYear', align: 'center' }},
    ]
  }

  nextInvoiceDateMap = (dateName: string, spo = false) => {
    switch (dateName) {
      case 'dateOfDispatch': return 'vieDispatchDate';
      case 'exwDate': return spo ? 'lineItems.extra.exwJapanDate' : 'exwJapanDate'
      case 'dateOfArrival': return spo ? 'lineItems.extra.arrivingVieDate' : 'arrivingVieDate';
      case 'dateOfDelivery': return 'etaCustomer';
      default: return dateName;
    }
  }

  constructor(
    public api: ApiService,
    protected auth: AuthGuardService,
    private elRef: ElementRef,
    public cdRef: ChangeDetectorRef,
    private datePipe: DatePipe,
    private cookie: CookieService,
    public data: SharedDataService,
    private toastr: NbToastrService,
    private tree: TreeService,
    protected dialogService: NbDialogService,
  ) {
    super(elRef, api, auth, data);

    // noninvoiced order confirmations
    this.pdfTables.noninvoiced = JSON.parse(JSON.stringify(this.pdfTables.default));
    this.pdfTables.noninvoiced.docTable[0].width = '8rem'; //'5.5rem';
    this.pdfTables.noninvoiced.docTable.find(f => f.name === 'accountManager').width = null; //'5.5rem';
    this.pdfTables.noninvoiced.docTable.find(f => f.name === 'customerDocumentNumber').width = null; //'6.5rem';
    this.pdfTables.noninvoiced.docTable.find(f => f.name === 'vieDispatchDate').compare = 'dateOfDispatch';
    this.pdfTables.noninvoiced.docTable.find(f => f.name === 'etaCustomer').compare = 'dateOfDelivery';
    this.pdfTables.noninvoiced.productExtra = {
      table: [
        { width: '7.5rem',   name: 'lineItems.extra.calcName',              header: 'PFSPO / OBIC', href: true },
        // { width: '7.5rem',   name: 'lineItems.extra.code',              header: 'PFSPO', href: true },
        { width: '4.3rem',   name: 'lineItems.extra.issueDate',         header: 'Issue dt',  align: 'center' },
        { width: '4.3rem',   name: 'lineItems.extra.exwJapanDate',  compare: 'lineItems.extra.exwDate', header: 'EXW date',  align: 'center' },
        { width: '4.3rem',name: 'lineItems.extra.internalExwDate', header: 'Int EXW',align: 'center' },
        { width: '4.3rem',name: 'lineItems.extra.arrivingVieDate', compare: 'lineItems.extra.dateOfVieArrival',header: 'ETA AT dt',align: 'center' },
        { width:  '8em',      name: 'lineItems.extra.supplier',           header: 'Supplier' },
        { width: '9.7rem',  name: 'lineItems.extra.productName',           header: 'Product name' },
        {  name: 'lineItems.extra.customerDocumentNumber',           header: 'Customer PO' },
        { width: '4rem',   name: 'lineItems.extra.quantity',           header: 'Quantity',  align: 'right' },
      ],
    };

    this.pdfTables.noninvoiced.docTable.splice(3, 0,
      { width: '4.3rem', name: 'expectedNextInvoiceDate', header: 'Invoice date', align: 'center' },
    )
    this.pdfTables.noninvoiced.productTable.splice(1, 0,
      { width: '2.5rem', name: 'li_popos', header: 'PO Pos', align: 'center'}, // PO position
      { width: '2rem', name: 'li_partdel', header: 'PD', align: 'center'}, // partial delivery
    )
    this.pdfTables.noninvoiced.docTable.splice(2, 6);
    this.pdfTables.noninvoiced.docTable2 = [this.getDateLineDocTable2(true)];
    this.pdfTables.noninvoiced.docTable.splice(3, 0,
      { width: '', name: 'projectNumber', header: 'Project Number' },
    )
    const idx = this.pdfTables.noninvoiced.docTable.findIndex(f => f.name === 'recipient');
    this.pdfTables.noninvoiced.docTable.splice(idx, 0, { width: '1.5rem', name: 'businessUnit', header: 'BU', align: 'left' });

    // console.log('pdftables', this.pdfTables.noninvoiced);
    // this.pdfTables.noninvoiced.docTable2 = [
    //   { label: { text: 'Issue Date:' }, data: { name: 'issueDate', align: 'center' }},
    //   { label: { text: 'Planned Next Invoice Date:' }, data: { name: 'expectedNextInvoiceDate', align: 'center' }},
    //   { label: { text: 'PO Date:' }, data: { name: 'customerDocumentDate', align: 'center' }},
    //   { label: { text: 'FAT date:' }, data: { name: 'dateOfFAT', align: 'center' }},
    //   { label: { text: 'Dispatch date:' }, data: { name: 'vieDispatchDate', align: 'center' }},
    //   { label: { text: 'Cust Req Date:' }, data: { name: 'customerReqDate', align: 'center' }},
    //   { label: { text: 'Cust Acc Date:' }, data: { name: 'customerAccDate', align: 'center' }},
    //   { label: { text: 'ETA Customer:' }, data: { name: 'etaCustomer', align: 'center' }},
    //   { label: { text: 'SAT Date:' }, data: { name: 'dateOfSAT', align: 'center' }},
    //   { label: { text: 'IN Due Date:' }, data: { name: 'dueDate', align: 'center' }},
    //   { label: { text: 'IN Due Next Date:' }, data: { name: 'expectedNextInvoiceDate', align: 'center' }},
    //   { label: { text: 'Fiscal Year:' }, data: { name: 'fiscalYear', align: 'center' }},
    // ]

    // orders
    this.pdfTables.orders = JSON.parse(JSON.stringify(this.pdfTables.default));
    this.pdfTables.orders.docTable.splice(3, 5,
      { width: '5rem', name: 'vieDispatchDate', header: 'Dispatch date', align: 'center', docs: /^(OC|IN|CN|PFIN|PFCN)/ },
      { width: '5rem', name: 'etaCustomer', header: 'ETA customer', align: 'center', docs: /^(OC|IN|CN|PFIN|PFCN)/ },
    );
    this.pdfTables.orders.docTable.push(
      { width: '3rem', name: 'completelyInvoiced', header: 'inv', align: 'center' }
    );
    this.pdfTables.orders.docTable.splice(2, 0,
      { width: '5rem', name: 'customerDocumentDate', header: 'PO date', align: 'center', docs: /^(OR)/ },
      { width: '5rem', name: 'orNotCompleted', header: 'Order status', align: 'center', docs: /^(OR)/ },
    );
    this.pdfTables.orders.productTable.splice(1, 0,
      { width: '5rem', name: 'lineItems.dateOfDelivery', header: 'CRDD', align: 'center', docs: /^OR/ },
      { width: '2.5rem', name: 'lineItems.li_popos', header: 'PO Pos', align: 'center', docs: /^OC/ },
      { width: '2rem', name: 'lineItems.partialDelivery', header: 'PD', align: 'center', docs: /^OC/ },
    )
    this.pdfTables.orders.productExtra = {
      table: this.pdfTables.noninvoiced.productExtra.table,
      docs: /^OC/,
      docTable2: [this.getDateLineDocTable2(false)],
    }
    this.pdfTables.orders.docTable2 = [this.getDateLineDocTable2(true)];

    // console.log('product extra', this.pdfTables);

    // last invoices
    this.pdfTables.lastinvoices = JSON.parse(JSON.stringify(this.pdfTables.default));
    this.pdfTables.lastinvoices.docTable.find(f => f.name === 'documentNumber').width = '5.5rem';
    this.pdfTables.lastinvoices.docTable.find(f => f.name === 'accountManager').width = null; //'6rem';
    this.pdfTables.lastinvoices.docTable.find(f => f.name === 'customerDocumentNumber').width = null; //'6rem';
    this.pdfTables.lastinvoices.docTable = this.pdfTables.lastinvoices.docTable
      .filter(f => f.name !== 'issueDate')
      .filter(f => f.name !== 'vieDispatchDate')
      .filter(f => f.name !== 'customerAccDate')
      .filter(f => f.name !== 'customerReqDate')
      .filter(f => f.name !== 'etaCustomer')
    this.pdfTables.lastinvoices.docTable2 = [
      [
        // { label: { width: '3rem', text: '' }, data: { width: '3rem', name: '', align: 'left' }},
        // { label: { width: '2.3rem', text: 'Due date:' }, data: { width: '3.3rem', name: 'dueDate', align: 'left' }},
        // { label: { width: '2.5rem', text: 'Next date:' }, data: { width: '3.3rem', name: 'nextPaymentDate', align: 'left' }},
        // { label: { width: '2.9rem', text: 'Fiscal year:' }, data: { width: '3.3rem', name: 'fiscalYear', align: 'left' }},
        // { label: { width: '2.9rem', text: 'Last update:' }, data: { width: '3.3rem', name: 'lastDueUpdate', align: 'left' }},
        // { label: { width: '1.2rem', text: 'User:' }, data: { width: '1.3rem', name: 'issuedBy', align: 'left' }},
        // { label: { width: '1.2rem', text: 'Info:' }, data: { width: '17rem', name: 'dueText', align: 'left' }},
        // { label: { text: 'Due date:' }, data: { name: 'dueDate', align: 'left' }},
        // { label: { text: 'Next date:' }, data: { name: 'nextPaymentDate', align: 'left' }},
        // { label: { text: 'Fiscal year:' }, data: { name: 'fiscalYear', align: 'left' }},
        { label: { text: 'Last update:' }, data: { name: 'lastDueUpdate', align: 'left' }},
        { label: { text: 'Last user:' }, data: { name: 'dueUser', align: 'left' }},
        { label: { text: 'Info:' }, data: { name: 'dueText', align: 'left', pre: true }},
      ],
      this.getDateLineDocTable2()
    ];
    this.pdfTables.lastinvoices.productExtra = {
      table: [...this.pdfTables.noninvoiced.productExtra.table],
    }
    // const crd = this.pdfTables.lastinvoices.docTable.find(f => f.name === 'customerReqDate');
    // crd.name = 'dueDate'; crd.header = 'Due date';
    // this.pdfTables.lastinvoices.docTable.push(
    //   { width: '2.5rem', name: 'invoiceStatus', header: 'paid', align: 'center'}
    // );

    // due invoices
    this.pdfTables.dueinvoices = JSON.parse(JSON.stringify(this.pdfTables.lastinvoices));
    // this.pdfTables.dueinvoices.docTable.splice(4,1); // remove due date
    // this.pdfTables.dueinvoices.docTable2 = [
    //   // { label: { width: '3rem', text: '' }, data: { width: '3rem', name: '', align: 'left' }},
    //   { label: { width: '2.3rem', text: 'Due date:' }, data: { width: '3.3rem', name: 'dueDate', align: 'left' }},
    //   { label: { width: '2.5rem', text: 'Next date:' }, data: { width: '3.3rem', name: 'nextPaymentDate', align: 'left' }},
    //   { label: { width: '2.9rem', text: 'Last update:' }, data: { width: '3.3rem', name: 'lastDueUpdate', align: 'left' }},
    //   { label: { width: '1.2rem', text: 'User:' }, data: { width: '1.3rem', name: 'issuedBy', align: 'left' }},
    //   { label: { width: '1.2rem', text: 'Info:' }, data: { width: '17rem', name: 'dueText', align: 'left' }},
    // ];

    // offers
    this.pdfTables.offers = JSON.parse(JSON.stringify(this.pdfTables.default));
    this.pdfTables.offers.docTable.splice(3, 3,
      { width: '5rem', name: 'offerValidity',              header: 'Offer validity',  align: 'center' },
    );

    // deliverynotes // => pages/warehousing
    this.pdfTables['deliverynotes'] = { ...this.pdfTables.noninvoiced };
    this.xlsTables['deliverynotes'] = [...this.xlsTables.noninvoiced];

    this.xlsTables['inventory'] = [...this.xlsTables.boxes];
  }

  async ngOnInit() {
    // this.cdRef.detach();
    super.init();
    this.transformScale = !this.warehousing && this.warehousingData.pdfData ? 1 : +this.cookie.get('transformScale') || 1.3;    
    // console.log('onInit', this.warehousing, this.warehousingData);
  }

  prevOffset = undefined;
  prevLimit = undefined;
  ngDoCheck() {

    if (!this.loading && this.prevOffset !== this.query.offset) {
      this.prevOffset = this.query.offset;
      if (this.prevOffset !== undefined) {
        this.reloadData();
      }
    } else if (!this.loading && this.prevLimit !== this.query.limit) {
      this.prevLimit = this.query.limit;
      if (this.prevLimit !== undefined) {
        this.reloadData();
      }
    }
  }

  getPdfTable(doc = null) {
    const type = this.getType();
    const table = Object.assign({}, this.pdfTables[type]);

    if (this.query && this.query.noPrices) {
      table.productTable = table.productTable?.filter(f => f.price !== true);
    }
    if (doc) {
      table.docTable = this.pdfTables[type]?.docTable.filter(f => !f.docs || f.docs && f.docs.test(doc.code));
    }
    return table;
  }

  filterRemarks(remark: ProjectRemark) {
    return remark?.items?.filter(f => !f.inactive);
  }

  getDocTable2ItemCount(doc, table) {
    return table.filter(f => !!this.getValue(doc, f.data.name))?.length;
  }

  private abort$ = new Subject<void>();
  abortReload() {
    console.log('abort reload');
    this.abort$.next();
  }

  loadingReports = {};

  isReloadingData = false;
  lastUpdate: Date;
  lastUpdateAgo = '';
  lastUpdateTimer = null;
  // subscriptions: Subscription[] = [];
  reloadData(forced = false, cached = true) {

    // this.abortReload(); // stop current loadings
    if (this.loadingReports[this.getType()]) {
      this.abortReload();
    }

    return new Promise(async resolve => {
      this.isReloadingData = true;

      let aborted = false;

      // Listen for abort signal
      const abortSub = this.abort$.subscribe(() => {
        aborted = true;
        this.loadingReports[this.getType()] = false;
      });

      // DnStatusComponent.clearShipmentStatus();
      // console.log('this.serch[type]', this.getType(), this.search)

      const type = this.getType();
      if (!type) {
        this.isReloadingData = false;
        abortSub.unsubscribe();
        this.loadingReports[this.getType()] = false;
        resolve(false);
      }

      this.query = this.search[type];
      if (!this.query) {
        this.isReloadingData = false;
        abortSub.unsubscribe();
        this.loadingReports[this.getType()] = false;
        resolve(false);
        return;
      }

      // => dateTo as full day
      if (this.query && this.query.dateTo && typeof this.query.dateTo.setHours === 'function') {
        this.query.dateTo.setHours(23);
        this.query.dateTo.setMinutes(59);
        this.query.dateTo.setSeconds(59);
      }
      // console.log('reload data', type, this.warehousing, this.dashboard, this.warehousingData);
      if (!forced && !this.warehousing && !this.dashboard && this.warehousingData.pdfData) {
        window.setTimeout(() => {
          this.pdfData = [...this.warehousingData.pdfData];
          this.totalCount = this.pdfData?.length;
          this.loading = false;
          this.isReloadingData = false;
          this.cdRef.detectChanges();
          // console.log('reloadData2', type, this.pdfData, this.loading, this.isReloadingData, this.warehousingData);
          abortSub.unsubscribe();
          this.loadingReports[this.getType()] = false;
          resolve(true);
        }, 0);
      } else {

        // if (this.subscriptions) {
        //   this.subscriptions.forEach(s => s.unsubscribe());
        //   this.subscriptions = [];
        // }

        await this.api.refreshTreeCache();
        // console.log('load report')
        // console.log('getDocumentReport', type, this.search, this.pdfSidebar);
        // this.subscriptions.push(this.api.getDocumentReport(type, this.search, this.pdfSidebar).subscribe({ next: async _data => {

        // console.log('pre getDocumentReport', type, this.search, this.pdfSidebar);


        if (!cached) {
          this.api.cacheInterceptor.invalidateCacheForUrl(this.api.getDocumentReportUrl(type, this.pdfSidebar));
        }

        const currentPdfData = this.pdfData;
        const _data = await firstValueFrom(
          this.api.getDocumentReport(type, this.search, this.pdfSidebar)
          .pipe(
            takeUntil(this.abort$),
            catchError(err => {
              // if (err.name === 'EmptyError') {
              //   // request aborted
              //   aborted = true;
              //   console.log('request aborted');

              //   resolve(false);
              //   return [];
              // }
              this.loading = false;
              this.error = 'error while receiving data: ' + err.message;
              this.reportMargin = this.calcMargin();
              this.isReloadingData = false;
              abortSub.unsubscribe();
              this.loadingReports[this.getType()] = false;              
              resolve(false);
              return [];
            })          
          )
        ).catch(e => {
          this.loading = false;
          this.error = 'error while receiving data: ' + e.message;
          this.reportMargin = this.calcMargin();
          this.isReloadingData = false;
          abortSub.unsubscribe();
          this.loadingReports[this.getType()] = false;              
          resolve(false);
          return [];
        })
        // .catch((error) => {
        //   this.loading = false;
        //   if (this.auth.user) console.error(error);
        //   this.error = 'error while receiving data: ' + error.message;
        //   this.reportMargin = this.calcMargin();
        //   this.isReloadingData = false;
        //   abortSub.unsubscribe();
        //   resolve(false);
        // })

        if (aborted) {
          abortSub.unsubscribe();
          this.loadingReports[this.getType()] = false;
          resolve(false);
          return;
        }
  
        if (!_data) {
          abortSub.unsubscribe();
          this.loadingReports[this.getType()] = false;
          resolve(false);
          return;
        }
        
        // console.log('after getDocumentReport', type, this.search, this.pdfSidebar, _data);

        if (this.pdfSidebar) {
          // console.log('load report subscription3')

          // _data.ret.forEach(el => console.log('data', el.documentNumber, el.dueDate));
          this.pdfData = _data.ret;
          this.totalCount = _data.totalCount;
          if (_data.csmap) {
            this.csmap = _data.csmap;
            this.query.combinedShipmentMap = Object.values(_data.csmap);  
          }

          if (this.printCount || this.dashboard) {
            this.headerText = `${_data.ret?.length}/${this.totalCount} `;
          } else {
            this.headerText = this.datePipe.transform(Date.now(), 'yyMMdd ');
          }

          if (this.getType() === 'inventory') {
            // this.onCreateInventoryList({table: this.pdfData.map(m => Object.values(m)), header: Object.keys(this.pdfData[0]).map(m => ({name: m}))}, true);
            this.onCreateInventoryList(this.pdfData, true);
            this.loading = false;
            this.isReloadingData = false;
            return;
          }

          this.dueInfoData = {};
          _data.ret?.forEach(el => {
            this.dueInfoData[el.code] = ({
                dueUser: el.dueUser,
                dueDate: el.dueDate,
                nextPaymentDate: el.nextPaymentDate,
                info: el.dueInfo,
                text: el.dueText
              })
          });
          // console.log('dueinfodata', this.dueInfoData);
          // console.log('===>pdf data', this.pdfData, this.pdfData.map(m => m.packingStatus));
          // console.log('due pdf data', this.pdfData, this.dueInfoData);
        } else {
          // console.log('load report subscription4')
          // console.log('query.....', type, this.query.extended,  this.query, this.xlsTables, _data, JSON.parse(JSON.stringify(_data)));
          if (this.xlsTables[type]) {
            this.currentTable = null;
            if (type === 'openspo' && this.query.extended === 3) this.currentTable = this.buildTimelineTable(this.xlsTables[type], _data)
            if (type === 'openspo' && this.query.extended === 4) this.currentTable = this.buildSpoTable(this.xlsTables[type], _data)
            if (type === 'inventory' && this.query.extended === 10) this.currentTable = this.buildStockOverviewTable(this.xlsTables[type], _data)
            if (type === 'inventory' && this.query.extended === 11) this.currentTable = this.xlsTables['inventoryMonthly'];
            if (type === 'boxes' && this.query.extended === 30) {
              this.currentTable = this.buildBoxTypeTable(this.xlsTables[type], _data);
            } else if (type === 'boxes') {
              this.currentTable = this.query.simple ? this.xlsTables[type].filter(f => !f.extended) : this.xlsTables[type];
            } else if (type === 'lastinvoices') {
              this.currentTable = this.xlsTables[type].filter(f => !f.extended || f.extended === this.query.extended);
            } else {
              switch (this.query.extended) {
                case 0: this.currentTable = this.xlsTables[type].filter(f => !f.extended && !f.extended2); break
                case 1: this.currentTable = this.xlsTables[type].filter(f => !f.extended2 && !f.notextended); break;
                case 2: this.currentTable = this.xlsTables[type]; break;
                // case 3: this.currentTable = this.xlsTables[type].filter(f => (!f.extended && !f.extended2) || f.timeline);
                case 5: this.currentTable = this.xlsTables['deliveryStatus']; break;
              }
              if (['offers'].includes(type) && this.query.extended) {
                this.currentTable = this.currentTable.filter(f => !f.notextended);
              }
            }
            if (this.query.noPrices) {
              this.currentTable = this.xlsTables[type].filter(f => f.type !== 'price');
            }
            if (this.query.projectOverview && type !== 'spopayment') this.currentTable = this.buildProjectOverviewTable(this.xlsTables.projectoverview, _data);
            if (this.query.expiryReport) this.currentTable = this.buildExpiryReportTable(this.xlsTables.expiryreport, _data, this.query);
            if (type === 'invoicedandopenorders' && this.query.quantitySummary) this.currentTable = this.buildQuantitySummaryTable(this.xlsTables[type], _data);
            // if (!this.currentTable) this.currentTable = this.xlsTables[type];
            if (!this.currentTable) this.currentTable = this.xlsTables[type];
          }
          // console.log('query current table', this.currentTable, this.query.quantitySummary, _data);
          this.xlsData = {};
          this.xlsData.heading = _data.heading;
          this.xlsData.header = this.currentTable;
          this.xlsData.map = _data.ret;

          // console.log('xls table', this.xlsData);
          // if (type === 'openspo' && this.query.extended === 3) this.xlsData.headerHeight = 50;
          // this.xlsData.table;
          if (_data.ret.sheets) {
            this.xlsData.table = { 
              sheets: _data.ret.sheets.map(m => ({
                name: m.name,
                data: m.data.map(m => this.currentTable.map(col => this.getValue(m, col.name, false))),
              }))
            }
          } else {
            // console.log('______data', this.currentTable, this.xlsTables, _data);
            this.xlsData.table = []
            _data.ret.forEach(row => {
              const res = [];
              this.currentTable.forEach(col => {
                res.push(this.getValue(row, col.name, false));
              });
              this.xlsData.table.push(res);
            });
            this.dueInfoData = _data.ret.map(m => m.dueInfo);
            // this.dueInfoPopupData = _data.ret.map(m => ({ reminder1: null, reminder2: null, reminder3: null, text: ''}));
            this.dueInfoPopupData = _data.ret.map(m => ({ 
              editMode: false,
              reminder: null, 
              dueDate: m.dueInfo?.[0]?.dueDate, 
              nextPaymentDate: m.dueInfo?.[0]?.nextPaymentDate,
              reminderDate: new Date(),  
              dueText: '',
            }));
          }

          // console.log('xls data', this.xlsData);

          this.setDisplayTable(0);
        }
        // console.log('load report subscription5')

        this.loading = false;
        if (this.cdRef && !(this.cdRef as ViewRef).destroyed) this.cdRef.detectChanges();
        // console.log('report loaded')
        this.done.emit({ params: this.search, pdfData: this.pdfData });
        this.reportMargin = this.calcMargin();
        const fpids = this.query.finishedProducts;
        if (fpids && fpids.length) {
          const fps = await Promise.all(fpids.map(async id => await this.api.loadFinishedProductById(id))) as FinishedProductModel[];
          this.finishedProductNames = fps && fps.length ? fps.map(fp => `${fp.calcName}\n${fp.calcCode}`).join('\n') : 'All';
        }

        this.warehousingData = { ...this.warehousingData, pdfData: this.pdfData, xlsData: this.xlsData };

        this.isReloadingData = false
        if (this.warehousing) {
          this.lastUpdate = new Date();
          // console.log('reset last update', this.lastUpdate)
          if (this.lastUpdateTimer) window.clearInterval(this.lastUpdateTimer);
          this.lastUpdateAgo = moment(this.lastUpdate).fromNow();
          this.lastUpdateTimer = window.setInterval(() => {
            // console.log('should we reload data?');
            const elapsed = moment().diff(this.lastUpdate, 'seconds');
            if (elapsed > 10*60) {
              // console.log('yes, reload data', elapsed, this.lastUpdate);
              this.reloadData(true, false); // refresh data automatically every 10 minutes
            }
            this.lastUpdateAgo = moment(this.lastUpdate).fromNow();
            this.cdRef.detectChanges;
          }, 60000);
        } else {
          if (this.lastUpdateTimer) window.clearInterval(this.lastUpdateTimer);
        }

        this.popupDocument?.reloadReportsData();
        
        abortSub.unsubscribe();
        this.loadingReports[this.getType()] = false;
        resolve(true);
      }
    });
  }

  getProductTableLength(doc) {
    let len = this.getPdfTable().productTable.filter(f => !f.docs?.test(doc.code))?.length;
    if (['IN','PFIN'].includes(CompilationTypeData.get(doc.type)?.code) && doc.lineItems.length > 1) len -= 2;
    // console.log('len', len)
    // this.getPdfTable().productTable.filter(f => console.log(f.docs));
    return len;
  }
  showProductTableItem(item: any, doc: any) {
    return !item.docs || item.docs.test(doc.code);
  }

  async openMetrics(docRef: Partial<CompilationModel>, idx: number) {

    const doc = await this.api.loadCompilationByCode(docRef.code);
    doc.lineItems.forEach(el => el.finishedProduct = this.data.finishedProducts.find(f => mongoId(f) === mongoId(el.finishedProduct)));

    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.metrics,
        compilation: doc,
        lineItem: doc.lineItems[idx],
        disabled: true,
      }
    })
  }

  buildSpoTable(xlsTable: any, data: any) {
    return xlsTable = [
      { name: 'documentNumber', header: '(PF)SPO ID' },
      { name: 'relatedCS', header: 'Grouped Shipment ID' },
      { name: 'meansOfTransport', header: 'Transport Method' },
      { name: 'exwDate', header: 'EXW Date' },
      { name: 'etaCustomer', header: 'ETA Customer Date' },
      { name: 'customerReference', header: 'Customer' },
      { name: 'lineItems.customerPoIds', header: 'Assigned Customer PO IDs' },
      { name: 'lineItems.relatedOCs', header: 'Related OCs' },
      { name: 'lineItems.assignedOcQuantity', header: 'OC Qty (assigned)' },
      { name: 'customerReqDate', header: 'CRDD' },
      { name: 'lineItems.unassignedOcQuantity', header: 'Non OC Qty (unassigned or free)' },
    ];
  }

  buildTimelineTable(xlsTable: any, data: any) {
    // append combined shipment columns (pivot table)
    const csColumns = distinctFromObjectArray(data.ret.map(m => ({ 
      name: m?.relatedCS, 
      header: `${m?.csExwDate?.replace(/T.*/,'') || ''}\n${m?.relatedCS}\n${m?.csInternal || ''}`
    })), 'name');

    xlsTable.push(...csColumns);
    data.ret.forEach(row => {
      csColumns.forEach(col => {
        if (row?.relatedCS && row.relatedCS === col.name) {
          row[col.name] = row['lineItems']['quantity'];
        }
      })
    })
    // console.log('xlstable', xlsTable, data);
    return xlsTable.filter(f => f.name && ((!f.extended && !f.extended2) || f.timeline));
  }

  buildProjectOverviewTable(xlsTable: any, data: any) {
    // console.log('buildProjectOverviewTable', xlsTable, data);

    const pmntColCount = Math.max(...data.ret.map(m => m.paymentPlanItems?.length || 0));
    for (let i = 1; i <= pmntColCount; i++) {
      xlsTable.push({
        name: 'payment' + i,
        header: 'OC Payment ' + i
      });
      data.ret.forEach(row => row['payment'+i] = row.paymentPlanItems[i-1] || '');
    }

    xlsTable.push(
      { name: 'totalNet', header: 'OC Total Net', format: 'currency' },
      { name: 'paymentSum', header: 'Sum IN Net', format: 'currency' },
      { name: 'ocRemaining', header: 'Remaining OC Value' },
    )

    const spoPmntColCount = Math.max(...data.ret.map(m => m.spoPaymentPlanItems?.length || 0));
    for (let i = 1; i <= spoPmntColCount; i++) {
      xlsTable.push({
        name: 'spoPayment' + i,
        header: 'SPO Payment ' + i
      });
      data.ret.forEach(row => row['spoPayment'+i] = row.spoPaymentPlanItems[i-1] || '');
    }
    // console.log('spoPayment', spoPmntColCount, xlsTable, data.ret);

    const spINcolCount = Math.max(...data.ret.map(m => m.spINs?.length || 0));
    for (let i = 1; i <= spINcolCount; i++) {
      xlsTable.push({
        name: 'supplierIN' + i,
        header: 'Supplier IN #' + i
      },
      {
        name: 'supplierINvalue' + i,
        header: 'Supplier IN Value' + i
      });
      data.ret.forEach(row => row['supplierIN'+i] = row.spINs[i-1] || '');
      data.ret.forEach(row => row['supplierINvalue'+i] = row.spINvalues[i-1] || '');
    }

    xlsTable.push(
      { name: 'spINsum', header: 'Sum Supplier IN Net', format: 'currency' },
      { name: 'spoTotalNet', header: 'SPO Total Net', format: 'currency' },
      { name: 'spoRemaining', header: 'Remaining SPO Value' },
      { name: 'projectMarkupCurrent', header: 'OC IN - SPIN', format: 'currency' },
      { name: 'projectMarkupTotal', header: 'Expected Project Markup Total', format: 'currency' },
    )

    return xlsTable;
  }

  buildExpiryReportTable(xlsTable: any, data: any, query: any) {
    if (query.withEnRoute) xlsTable = this.xlsTables['expirywithenroute'];
    xlsTable.heading = moment().format('YYMMDD') + ' Inventory Report' + (query.withEnRoute ? ' With En Route' : '')
    // console.log('build expiry data', data);
    if (!query.extended) {
      xlsTable = xlsTable.filter(f => !f.extended);
    }
    // console.log('build expiry data', data, xlsTable, query);
    return xlsTable;
  }

  buildStockOverviewTable(xlsTable: any, data: any) {

    data.heading = [moment().format('YYMMDD') + ' NRKA Inventory'];

    // console.log('buildStockOverviewTable', data, this.xlsData);

    xlsTable = [
      { name: 'spoCustomerReference', header: 'PFSPO Customer', extended: 10 },
      { name: 'spoCalcCode', header: 'PFSPO Product #', extended: 10 },
      { name: 'spoCalcName', header: 'PFSPO Product Name', extended: 10 },
      { name: 'spoDimensions', header: 'PFSPO Product Dimensions', extended: 10 },
      { name: 'spoPiecePrice', header: 'PFSPO Price/Piece', align: 'right', extended: 10 },
      { name: 'spoQuantity', header: 'Quantity pcs', align: 'right' },
      { name: 'netTotal', header: 'Sum Value', align: 'right', format: 'currency' },
    ]

    // const eur = data.filter(f => f.spoCurrency.toUpperCase() === 'EUR');
    // const usd = data.filter(f => f.spoCurrency.toUpperCase() === 'USD');

    const grouped = data.ret.reduce((a, c) => {

      if (!a[`${c.spoCurrency}-${c.spoCalcCode}`]) {
        a[`${c.spoCurrency}-${c.spoCalcCode}`] = {
          ...c,
          spoQuantity: 0,
          netTotal: 0,
        }
      }
      a[`${c.spoCurrency}-${c.spoCalcCode}`].spoQuantity += c.quantity;
      a[`${c.spoCurrency}-${c.spoCalcCode}`].netTotal += c.quantity * c.spoPiecePrice;

      return a;
    }, {})

    // console.log('grouped', grouped);

    const eur = Object.values(grouped as any[])
      .filter(f => f.spoCurrency === 'EUR')
      .sort((a, b) => 
        a.spoCustomerReference < b.spoCustomerReference
        ? -1
        : a.spoCustomerReference > b.spoCustomerReference
          ? 1
          : 0
      );
    eur.push({ netTotal: eur.reduce((a, c) => a += c.netTotal, 0)});

    const usd = Object.values(grouped as any[])
      .filter(f => f.spoCurrency === 'USD')
      .sort((a, b) => 
        a.spoCustomerReference < b.spoCustomerReference
        ? -1
        : a.spoCustomerReference > b.spoCustomerReference
          ? 1
          : 0
      );
    usd.push({ netTotal: usd.reduce((a, c) => a += c.netTotal, 0)});

    data.ret = [
      {},
      { spoCustomerReference: 'PFSPO Currency', spoCalcCode: 'USD'},
      {},
      ...usd,
      {},
      { spoCustomerReference: 'PFSPO Currency', spoCalcCode: 'EUR'},
      {},
      ...eur,
    ]

    data.totalCount = data.ret.length;

    // console.log('grouped data', data)

    return xlsTable;
  }

  buildBoxTypeTable(xlsTable: any, data: any) {
    const grouped = data.ret.reduce((a, c) => {

      if (!a[`${c.boxType}-${c.spoCalcCode}`]) {
        a[`${c.boxType}-${c.spoCalcCode}`] = c;
      }

      return a;
    }, {})
    data.ret = Object.values(grouped);
    data.length = data.ret.length;
    return [
      // { name: 'palletId', header: 'Pallet ID', align: 'center' },
      // { name: 'boxId', header: 'Box ID', align: 'center' },
      // { name: 'boxNr', header: 'Box #', align: 'center' },
      // { name: 'lot', header: 'Lot #' },
      // { name: 'quantity', header: 'Q', align: 'right' },
      // { name: 'tc', header: 'TC #' },
      { name: 'boxType', header: 'Box Type', extended: 30 },
      { name: 'fpBoxType', header: 'FP Box Type', extended: 30 },
      { name: 'boxStatus', header: 'Box Status', extended: 30 },
      { name: 'spoCustomerReference', header: 'PFSPO Customer', extended: 10 },
      { name: 'spoCalcCode', header: 'PFSPO Product #', extended: 20 },
      { name: 'spoCalcName', header: 'PFSPO Product Name', extended: 20 },
      { name: 'spoDimensions', header: 'PFSPO Product Dimensions', extended: 20 },
      // { name: 'prodDate', header: 'Prod Date' },
      // { name: 'minProdDate', header: 'Oldest PD', extended: 20 },
      // { name: 'maxProdDate', header: 'Newest PD', extended: 20 },
      // { name: 'shelfLifeText', header: 'Shelf Life Text' },
      // { name: 'shelfLifeDate', header: 'Shelf Life Date', extended: 20 },
      // { name: 'shelfLifeDateOverride', header: 'Shelf Life Date Override', extended: 20 },
      { name: 'obic', header: 'OBIC', extended: 20 },
      { name: 'spo', header: 'PFSPO #', extended: 20 },
      { name: 'spoPos', header: 'PFSPO Pos', extended: 20 },
      { name: 'spoCountry', header: 'PFSPO Country', extended: 20, hidden: true },
      { name: 'spoRecipient', header: 'PFSPO Recipient', extended: 20 },
      // { name: 'spoPiecePrice', header: 'PFSPO Price/Piece', align: 'right', extended: 10 },
      // { name: 'spoBoxPrice', header: 'PFSPO Price/Box', align: 'right', extended: 10 },
      // { name: 'spoCurrency', header: 'PFSPO Currency', extended: 10 },
      { name: 'exwDate', header: 'EXW Date', extended: 20 },
      { name: 'arrivalDate', header: 'ETA AT Date', extended: 20 },
      // { name: 'spoPalNr', header: 'PFSPO Pallet #', extended: 20, align: 'center' },
      { name: 'dnCustomerDoc', header: 'Customer PO #' },
      // { name: 'dnPartdel', header: 'PD X/Y', align: 'center' },
      { name: 'oc', header: 'OC #' },
      { name: 'dn', header: 'DN #' },
      { name: 'dnPos', header: 'DN/OC Pos' },
      { name: 'dnRecipient', header: 'DN/OC Customer' },
      { name: 'dnCountry', header: 'DN/OC Country', extended: 20, hidden: true },
      { name: 'dispatchDate', header: 'Dispatch Date' },
      { name: 'dnCalcCode', header: 'DN/OC Product #' },
      { name: 'dnCalcName', header: 'DN/OC Product Name', extended: 20 },
      { name: 'dnDimensions', header: 'DN/OC Product Dimensions' },
      // { name: 'ocPiecePrice', header: 'OC Price/Piece', align: 'right', extended: 20 },
      // { name: 'ocBoxPrice', header: 'OC Price/Box', extended: 20, align: 'right' },
      // { name: 'dnPalNr', header: 'DN/OC Pallet #', extended: 20, align: 'center' },
      { name: 'stockStatus', header: 'Box Stock Status', extended: 20 },
      { name: 'customerProductCode', header: 'Customer Product Code' },
      { name: 'customerProductName', header: 'Customer Product Name' },
    ]
  }

  // [#2820]
  buildQuantitySummaryTable(xlsTable: any, data: any) {
    // console.log('build quantity summary table', xlsTable.filter(f => f.extended === 1), JSON.parse(JSON.stringify(data)));
    // const csColumns = distinctFromObjectArray(data.ret.map(m => ({ 
    //   name: m?.relatedCS, 
    //   header: `${m?.csExwDate?.replace(/T.*/,'') || ''}\n${m?.relatedCS}\n${m?.csInternal || ''}`
    // })), 'name');

    // xlsTable.push(...csColumns);
    // data.ret.forEach(row => {
    //   csColumns.forEach(col => {
    //     if (row?.relatedCS && row.relatedCS === col.name) {
    //       row[col.name] = row['lineItems']['quantity'];
    //     }
    //   })
    // })

    // const xls = xlsTable.filter(f => f.extended === 1);
    // data.ret = data.ret?.map(m => xls.map(xm => { [xm.name]: m[xm.name] }));

    const unit = UnitData.get(this.query.quantitySummaryUnit)
    data.heading = 'Quantity Summary in ' + unit.short;

    // agglomerate data
    const yearMonthsSet = new Set<string>();
    const products = [];
    const grouped = data.ret.reduce((a, c) => {

      const yearMonth = moment(c.vieDispatchDate).format('yyyy-MM')

      // console.log('company name', c.companyName)

      if (!a[`${c.companyName}-${c.productCode}-${yearMonth}`]) {
        a[`${c.companyName}-${c.productCode}-${yearMonth}`] = {
          ...c,
          monthQuantityPc: 0,
          monthQuantityLM: 0,
          monthQuantityM2: 0,
          monthQuantityKg: 0,
        }
        yearMonthsSet.add(yearMonth);
        products[`${c.companyName}-${c.productCode}`] = c
      }
      a[`${c.companyName}-${c.productCode}-${yearMonth}`].monthQuantityPc += c.quantity;
      a[`${c.companyName}-${c.productCode}-${yearMonth}`].monthQuantityLM += c.quantityLM;
      a[`${c.companyName}-${c.productCode}-${yearMonth}`].monthQuantityM2 += c.quantityM2;
      a[`${c.companyName}-${c.productCode}-${yearMonth}`].monthQuantityKg += c.quantityKg;
      return a;
    }, {})

    // console.log('grouped', grouped);

    const yearMonths = Array.from(yearMonthsSet);

    data.ret = Object.keys(products).map(m => {
      const row = Object.entries(grouped).find(([k, v]) => k.includes(m))?.[1] as any;
      row.product = row.calculatedName?.split(';')?.[0]?.trim() ?? '';
      row.dims = row.calculatedName?.split(';')?.[1]?.trim() ?? '';
      switch (unit.id) {
        case 1: // pc
          yearMonths.forEach(ym => row[ym] = round(grouped[`${m}-${ym}`]?.monthQuantityPc, 6) ?? '');
          row.total = round(yearMonths.reduce((a, c) => a + (grouped[`${m}-${c}`]?.monthQuantityPc ?? 0), 0), 2) ?? '';
          break;
        case 2: // m
          yearMonths.forEach(ym => row[ym] = round(grouped[`${m}-${ym}`]?.monthQuantityLM, 6) ?? '');
          row.total = round(yearMonths.reduce((a, c) => a + (grouped[`${m}-${c}`]?.monthQuantityLM ?? 0), 0), 2) ?? '';
          break;
        case 4: // m2
          yearMonths.forEach(ym => row[ym] = round(grouped[`${m}-${ym}`]?.monthQuantityM2, 6) ?? '');
          row.total = round(yearMonths.reduce((a, c) => a + (grouped[`${m}-${c}`]?.monthQuantityM2 ?? 0), 0), 2) ?? '';
          break;
        case 5: // kg
          yearMonths.forEach(ym => row[ym] = round(grouped[`${m}-${ym}`]?.monthQuantityKg, 6) ?? '');
          row.total = round(yearMonths.reduce((a, c) => a + (grouped[`${m}-${c}`]?.monthQuantityKg ?? 0), 0), 2) ?? '';
          break;
      }
      return row;
    })

    // const additionalColumns = Object.keys(grouped).map(m => ({ name: m.replace(/.*-/, ''), header: m.replace(/.*-/, '')}))
    const additionalColumns = Array.from(yearMonths).sort().map(m => ({ name: m, header: `${m} (${unit.short})` }))

    xlsTable = xlsTable.filter(f => f.extended === 1);

    xlsTable.push(
      { name: 'product', header: 'productName' },
      { name: 'dims', header: 'Dimensions' },
      { name: 'customerCode', header: 'Customer Code' },
      ...additionalColumns,
      { name: 'total', header: 'Total ' + unit.short}
    );

    // const newData = data.ret?.map(m =>
    //   xlsTable.reduce((obj, xm) => {
    //     obj[xm.name] = m[xm.name];
    //     return obj;
    //   }, {} as Record<string, any>)
    // );

    // data.ret.forEach((el, idx) => {
    //   newData[idx].product = el.calculatedName?.split(';')?.[0]?.trim() ?? '';
    //   newData[idx].dims = el.calculatedName?.split(';')?.[1]?.trim() ?? '';
    // })

    // data.ret = newData;

    // console.log('build xls', xlsTable, data);
    return xlsTable;
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (!this.loading && changes.search && changes.search.firstChange && changes.search.currentValue) {
      this.reloadData();
    }
    // console.log('pdfdata on changes', changes.search);
  }

  getStyle() {
    if (this.dashboard) {
      return { transform: 'scale(' + this.dashboardTransformScale + ')', margin: this.reportMargin + 'px auto', border: 'none' }
    } else if (this.warehousingPopup) {
      return { 'margin-bottom': '0' }
    } else if (this.messaging) {
      return { 'border':'none', 'transform-origin': 'top', transform: 'scale(' + this.transformScale + ')', 'margin-bottom': (this.reportMargin*2+100) + 'px' }
    } else {
      return { 'transform-origin': 'top', transform: 'scale(' + this.transformScale + ')', 'margin-bottom': (this.reportMargin*2+100) + 'px' }
    }
  }

  onScroll(event) {
    this.scroll.emit({ event: event, scrollbox: this.scrollbox });
  }

  scaleView(scale) {
    this.transformScale = scale;
    this.reportMargin = this.calcMargin();
    this.cookie.put('transformScale', ''+this.transformScale);
  }

  getSubtotalGross(item: any) {
    let sum = 0;
    item.lineItems.forEach(li => sum += this.calcNet(item, li));
    item.deductibleItems.forEach(li => sum += li.value);
    return sum;
  }

  getSubtotalProgressPayment(item: any) {
    return item.progressPaymentInvoices?.reduce((sum, li) => sum += li.net, 0);
  }

  getSubTotalNet(item: any) {
    let sum = 0;
    item.lineItems.forEach(li => sum += this.calcNet(item, li));
    item.deductibleItems.forEach(li => sum += li.value);
    item.progressPaymentInvoices?.forEach(li => sum += li.net);
    return sum;
  }

  getSubTotalKg(item: any) {
    let sum = 0;
    item.lineItems.forEach(li => sum += li.weight);
    return sum.toFixed(2);
  }

  getTotalNetProgressPayment() {
    let sum = 0;
    this.pdfData.forEach(el => el.progressPaymentInvoices?.forEach(li => sum += li.net));
    return sum;
  }

  getTotalNetGross() {
    let sum = 0;
    this.pdfData.forEach(el => el.lineItems.forEach(li => sum += this.calcNet(el, li)));
    this.pdfData.forEach(el => el.deductibleItems.forEach(li => sum += li.value));
    return sum;
  }

  getTotalNet() {
    let sum = 0;
    this.pdfData.forEach(el => el.lineItems.forEach(li => sum += this.calcNet(el, li)));
    this.pdfData.forEach(el => el.deductibleItems.forEach(li => sum += li.value));
    this.pdfData.forEach(el => el.progressPaymentInvoices?.forEach(li => sum += li.net));
    return sum;
  }

  getTotalWeight() {
    let sum = 0;
    this.pdfData.forEach(el => el.lineItems.forEach(li => sum += li.weight));
    return sum;
  }

  getOrOcTotalNet() {
    let orsum = 0;
    let ocsum = 0;
    let insum = 0;
    let cnsum = 0;
    let sposum = 0;
    this.pdfData.forEach(el => {
      if (/^OR/.test(el['code'])) el.lineItems.forEach(li => orsum += this.calcNet(el, li))
      if (/^OR/.test(el['code'])) el.deductibleItems.forEach(li => orsum += li.value)
      if (/^OR/.test(el['code'])) el.progressPaymentInvoices?.forEach(li => orsum += li.net)
      if (/^OC/.test(el['code'])) el.lineItems.forEach(li => ocsum += this.calcNet(el, li))
      if (/^OC/.test(el['code'])) el.deductibleItems.forEach(li => ocsum += li.value)
      if (/^OC/.test(el['code'])) el.progressPaymentInvoices?.forEach(li => ocsum += li.net)
      if (/^(PFIN|IN)/.test(el['code'])) el.lineItems.forEach(li => insum += this.calcNet(el, li))
      if (/^(PFIN|IN)/.test(el['code'])) el.deductibleItems.forEach(li => insum += li.value)
      if (/^(PFIN|IN)/.test(el['code'])) el.progressPaymentInvoices?.forEach(li => insum += li.net)
      if (/^CN/.test(el['code'])) el.lineItems.forEach(li => cnsum += this.calcNet(el, li))
      if (/^CN/.test(el['code'])) el.deductibleItems.forEach(li => cnsum += li.value)
      if (/^CN/.test(el['code'])) el.progressPaymentInvoices?.forEach(li => cnsum += li.net)
      if (el.spos) el.spos.forEach(spo => sposum+= spo.doc.lineItems[spo.pos-1] ? spo.doc.lineItems[spo.pos-1].piecePrice * spo.quantity : 0)
    });
    return [orsum, ocsum, insum, cnsum, sposum];
  }

  getOverdueTotalNet() {
    let net = 0;
    this.pdfData.forEach(el => {
      if (moment(new Date(el.dueDate)).diff(moment(new Date()), 'days') < 0) {
        el.lineItems.forEach(li => net += (li.net || 0));
        el.deductibleItems.forEach(di => net += (di.value || 0));
        el.progressPaymentInvoices?.forEach(di => net += (di.net || 0));
      }
    });
    return net;
  }
  getDueTotalNet() {
    let net = 0;
    this.pdfData.forEach(el => {
      if (moment(new Date(el.dueDate)).diff(moment(new Date()), 'days') >= 0) {
        el.lineItems.forEach(li => net += (li.net || 0));
        el.deductibleItems.forEach(di => net += (di.value || 0));
        el.progressPaymentInvoices?.forEach(di => net += (di.net || 0));
      }
    });
    return net;
  }


  getIndex(section, doc, idx) {
    let ct = 0;
    for (let i = 0; i < this.pdfData.length; i++) {
      if (this.pdfData[i][section] === doc[section]) ct++;
      if (i === idx) break;
    }
    return ct;
  }

  getDocIndex(doc, idx) {
    if (this.search.orders) {
      if (this.search.orders.relatedOcs > 1) {
        let ct = 0;
        if (this.query.sortByManager) {
          for (let i = 0; i < this.pdfData.length; i++) {
            if (this.pdfData[i]['accountManager'] === doc['accountManager']&& /^OR/.test(this.pdfData[i]['code'])) ct++;
            if (i === idx) break;
          }
          return /^OR/.test(doc['code']) ? ct : (/^OC/.test(doc['code']) ? '↳' : '→');
        }
        for (let i = 0; i < this.pdfData.length; i++) {
          if (this.pdfData[i]['recipient'] === doc['recipient'] && /^OR/.test(this.pdfData[i]['code'])) ct++;
          if (i === idx) break;
        }
        return /^OR/.test(doc['code']) ? ct : (/^OC/.test(doc['code']) ? '↳' : '→');
      }
      return this.getIndex(this.query.sortByManager ? 'accountManager' : 'recipient', doc, idx);
    }

    if (this.query.sortByManager) {
      return this.getIndex('accountManager', doc, idx);
    } else {
      if (this.search.lastinvoices || this.search.dueinvoices) {
        return this.getIndex('issuer', doc, idx);
      }
    }
    return idx + 1;
  }

  // getDocStyle(doc: CompilationModel, docidx, level = 2) {
  //   let opacity = 1;
  //   if (/^(PF)?SPO/.test(doc.code)) {
  //     opacity = 0.88;
  //     if (level === 1) {
  //       if (doc.transportRun && doc.transportRun.spoStatus === 1) {
  //         return { 'background-color': 'green' }
  //       } else {
  //         return { 'background-color': 'red' }
  //       }
  //     }
  //   }

  //   if (level !== 2) return;
  //   if (this.showDocHeader(docidx)) return { 'background-color': 'white', 'border-top': '1px solid lightgray', 'opacity': opacity };
  //   if (this.search.orders && this.search.orders.relatedOcs > 1) {
  //     // if (/^(OR)/.test(doc['code'])) {
  //     //   return { 'border-top': '1px solid lightgray' }
  //     // }
  //     if (/^(OC)/.test(doc['code'])) {
  //       return { 'background-color': '#dcdcdc', 'padding-left': '1em' };
  //     } else if (/^(IN|PFIN)/.test(doc['code'])){
  //       return { 'background-color': '#e8e8e8', 'padding-left': '2em' };
  //     } else if (/^CN/.test(doc['code'])) {
  //       return { 'background-color': '#efefef', 'padding-left': '3em' };
  //     } else {
  //       return null;
  //     }
  //   }
  //   if (this.getDocIndex(doc, docidx) % 2 === 0) {
  //     return { 'background-color': '#e8e8e8', 'opacity': opacity };
  //   }
  //   return { 'background-color': 'white', 'opacity': opacity };
  // }

  getDocStyle(doc, docidx) {
    // if (this.showDocHeader(docidx)) return { 'border-top': '1px solid lightgray' };
    if (doc.backgroundColor) {
      return { 'background-color': doc.backgroundColor }
    }

    if (this.search.orders && !doc.orNotCompleted && /^OR/.test(doc.code)) {
      return { 'background-color': '#dfd' }
    }

    if (this.search.orders?.relatedOcs > 1) {
      // if (/^(OR)/.test(doc['code'])) {
      //   return { 'border-top': '1px solid lightgray' }
      // }
      if (/^(OC)/.test(doc['code'])) {
        return { 'background-color': '#dcdcdc', 'padding-left': '1em' };
      } else if (/^(IN|PFIN)/.test(doc['code'])){
        return { 'background-color': '#e8e8e8', 'padding-left': '2em' };
      } else if (/^CN/.test(doc['code'])) {
        return { 'background-color': '#efefef', 'padding-left': '3em' };
      } else if (doc.spos)
        return { 'background-color': '#f4f4f4' };
      {
        return null;
      }
    }
    if (this.getDocIndex(doc, docidx) % 2 === 0) {
      return { 'background-color': '#e8e8e8' };
    }
    return null;
  }

  getDocColor(doc, docidx) {
    if (this.search.orders && this.search.orders.relatedOcs > 1) {
      return /^(OC|PFIN|IN)/.test(doc['code'])
    } /* else if (this.search.openspo) {
      let ct = 0;
      for (let i = 0; i < docidx; i++) {
        if (this.itemHasChanged('doctype', docidx, 'relatedCS', '(.*)')) ct++;
      }
      return ct % 2 === 1;
    } */
    return this.getDocIndex(doc, docidx) % 2 === 0
  }

  itemHasChanged(name: string, idx: number, field = 'code', regex = '(.+NRK.).*') {
    if (idx === 0) return true;
    if (name === 'doctype') {
      const rx = new RegExp(regex);
      const prevType = (this.pdfData[idx-1][field] || '').replace(rx, '$1');
      const currType = (this.pdfData[idx][field] || '').replace(rx, '$1');
      return prevType !== currType;
    }
    return this.pdfData[idx][name] !== this.pdfData[idx-1][name];
  }

  itemWillChange(name: string, idx: number, field = 'code', regex = '(.+NRK.).*') {
    if (idx === this.pdfData.length-1) return true;
    if (name === 'doctype') {
      const rx = new RegExp(regex);
      const nextType = (this.pdfData[idx+1][field] || '').replace(rx, '$1');
      const currType = (this.pdfData[idx][field] || '').replace(rx, '$1');
      return nextType !== currType;
    }
    return this.pdfData[idx][name] !== this.pdfData[idx+1][name];
  }

  checkPageBreak(idx, doc = null) {
    if (idx === 0) return false;
    return (this.query.sortByManager && this.itemHasChanged('accountManager',idx)) || doc?.sectionHeader;
  }


  showSectionTitle(idx) {
    if (this.query.sortByManager && this.itemHasChanged('accountManager',idx)) {
      return this.pdfData[idx].accountManager
    } else if (!this.query.sortByManager && this.itemHasChanged('issuer', idx)) {
      if ((this.query === this.search.lastinvoices )
        || (this.query === this.search.dueinvoices)) {
        return this.pdfData[idx].issuer === 2 ? 'NRKA' : 'NRKG'; // TODO: ...
      }
    }
  }

  checkCurrentOverdue(docidx: number) {
    const current = moment(new Date(this.pdfData[docidx].dueDate)).diff(moment(new Date()), 'days');
    return current < 0;
  }

  checkDueOverdueChange(docidx: number) {
    const prev = moment(new Date(this.pdfData[docidx-1].dueDate)).diff(moment(new Date()), 'days');
    return prev < 0 && !this.checkCurrentOverdue(docidx);
  }

  showOverdueGrace(docidx: number): boolean {
    const prevIsLastWeek = moment(new Date(this.pdfData[docidx-1].dueDate)).isBefore(moment().subtract(1, 'week'));
    const currIsThisWeek = moment(new Date(this.pdfData[docidx].dueDate)).isBetween(moment().subtract(1, 'week'), moment());
    // console.log('showOverdueGrace', prevIsLastWeek && currIsThisWeek, this.pdfData[docidx].code, moment().startOf('week').toDate(), moment(this.pdfData[docidx].dueDate).startOf('day').toDate(), moment().toDate() )
    return prevIsLastWeek && currIsThisWeek;
  }

  // checkCurrentBusinessStateChange(docidx: number) {
  //   if (this.dashboard) return null;
  //   if (docidx === 0) {
  //     if (this.pdfData[docidx].businessStatus === EBusinessStatus.active) return 'Active Business';
  //     if (this.pdfData[docidx].businessStatus === EBusinessStatus.new) return 'New Business';
  //     if (this.pdfData[docidx].businessStatus === EBusinessStatus.default) return 'Default Business';
  //   } else {
  //     if (this.pdfData[docidx].businessStatus === EBusinessStatus.active && this.pdfData[docidx-1].businessStatus !== EBusinessStatus.active) return 'Active Business';
  //     if (this.pdfData[docidx].businessStatus === EBusinessStatus.new && this.pdfData[docidx-1].businessStatus !== EBusinessStatus.new) return 'New Business';
  //     if (this.pdfData[docidx].businessStatus === EBusinessStatus.default && this.pdfData[docidx-1].businessStatus !== EBusinessStatus.default) return 'Default Business';
  //   }
  //   return null;
  // }

  showDocTitle(idx) {
    if (this.query.sortByManager) {
      if (this.itemHasChanged('doctype', idx) && this.query === this.search.lastinvoices) {
        const code = this.pdfData[idx].code.replace(/NRK.*/, '')
        return CompilationTypeData.get(code).name;
      }
    } else {
      if (this.itemHasChanged('doctype', idx) && this.query === this.search.lastinvoices) {
        const code = this.pdfData[idx].code.replace(/NRK.*/, '')
        return CompilationTypeData.get(code).name;
      }
      if (this.itemHasChanged('recipient', idx) && this.query === this.search.orders) {
        return this.pdfData[idx].recipient;
      }
      if (this.itemHasChanged('relatedCS', idx) && this.query === this.search.openspo && this.query.sortType === 1) {
        const cs = this.pdfData[idx].relatedCS;
        return cs || 'CS not assigned';
      }
    }
  }
  getSum(idx, docCode, ...test) { 
    return this.getSectionTotal(this.pdfData[idx], docCode) || 0;
  }
  formatSum(sum: number) {
    return formatCurrency(sum, 'de', '€', null, '1.2-2')
  }
  showDocTitleRight(idx) {
    if (!this.query.sortByManager && this.itemHasChanged('recipient', idx) && this.query === this.search.orders) {
      const ocval = this.getSectionTotal(this.pdfData[idx], 'OC')
      const inval = this.getSectionTotal(this.pdfData[idx], '(PFIN|IN)')
      const cnval = this.getSectionTotal(this.pdfData[idx], 'CN')
      const spoval = this.getSectionTotal(this.pdfData[idx], '(PF)SPO')
      const ret = { col1: [
        formatCurrency(this.getSectionTotal(this.pdfData[idx], 'OR'), 'de', '€', null, '1.2-2') + (ocval ? ' (OR)':''),
      ], col2: []};
      if (ocval) ret.col1.push(formatCurrency(ocval, 'de', '€', null, '1.2-2') + ' (OC)')
      if (inval) ret.col1.push(formatCurrency(inval, 'de', '€', null, '1.2-2') + ' (IN)  ')
      if (cnval) ret.col1.push(formatCurrency(cnval, 'de', '€', null, '1.2-2') + ' (CN)')
      if (cnval) ret.col2.push(formatCurrency(inval+cnval, 'de', '€', null, '1.2-2') + ' (IN-CN)     ')
      if (this.query.showMarkup > 1 && spoval) ret.col2.push(formatCurrency(spoval, 'de', '€', null, '1.2-2') + ' ((PF)SPO)')
      if (this.query.showMarkup > 1 && spoval) ret.col2.push(formatCurrency(inval + cnval - spoval, 'de', '€', null, '1.2-2') + ' (Profit)     ')
      return ret;
    }
  }

  showDocHeader(idx) {
    return idx === 0 || this.checkPageBreak(idx)
      || ((!this.query.sortByManager && this.itemHasChanged('issuer', idx)
        && (this.query === this.search.lastinvoices || this.query === this.search.dueinvoices)))
      || (!this.query.sortByManager && this.itemHasChanged('recipient', idx)
        && this.query === this.search.orders)
      || (this.itemHasChanged('doctype', idx)
        && this.query === this.search.lastinvoices)
  }

  showDocFooter(idx) {
    if (this.query.sortByManager) {
      if (this.itemWillChange('doctype', idx) && this.query === this.search.lastinvoices) return true
      if (this.itemWillChange('accountManager', idx)) return true
    } else {
      if (this.query === this.search.lastinvoices && this.itemWillChange('doctype', idx)) return true;
      if (this.query === this.search.dueinvoices && this.itemWillChange('issuer', idx)) return true;
    }
    return false;
  }

  getSectionTotalGross(doc, type?) {
    let sum = 0;
    if (this.query.sortByManager && this.query === this.search.noninvoiced) {
      this.pdfData.forEach(el => {
        if (el['accountManager'] === doc['accountManager'] && /^OC/.test(el['code'])) {
            el.lineItems.forEach(li => sum += this.calcNet(el, li));
            el.deductibleItems.forEach(li => sum += li.value);
        }
      });
      return sum;
    }
    return null;
  }

  getSectionProgressPayment(doc, type?) {
    let sum = 0;
    if (this.query.sortByManager && this.query === this.search.noninvoiced) {
      this.pdfData.forEach(el => {
        if (el['accountManager'] === doc['accountManager'] && /^OC/.test(el['code'])) {
          el.progressPaymentInvoices?.forEach(li => sum += li.net);
        }
      });
      return sum;
    }
    return null;
  }

  getSectionTotal(doc, type?) {
    let section;
    let sum = 0;
    if (this.query.sortByManager) {
      if (this.query === this.search.orders) {
        this.pdfData.forEach(el => {
          if (el['accountManager'] === doc['accountManager'] && /^OR/.test(el['code'])) {
            el.lineItems.forEach(li => sum += this.calcNet(el, li));
            el.deductibleItems.forEach(li => sum += li.value);
            el.progressPaymentInvoices?.forEach(li => sum += li.net);
          }
        });
        return sum;
      }
      if (this.query === this.search.lastinvoices) return this.getDoctypeTotal(doc, 'accountManager');
      section = 'accountManager';
      if (this.query === this.search.dueinvoices && [1,2,3].includes(this.query.reportNum)) {
        const bu = doc.lineItems?.[0]?.productName?.replace(/^(\w+)-.*/, '$1');
        this.pdfData.forEach(el => {
          if (el[section] === doc[section]) el.lineItems.filter(f => new RegExp(`^${bu}`).test(f.productName))?.forEach(li => sum += this.calcNet(el, li))
          if (el[section] === doc[section]) el.deductibleItems.filter(f => new RegExp(`^${bu}`).test(f.productName))?.forEach(li => sum += li.value)
          if (el[section] === doc[section]) el.progressPaymentInvoices?.filter(f => new RegExp(`^${bu}`).test(f.productName))?.forEach(li => sum += li.net)
        });
        return sum;
      }
    } else {
      if (this.query === this.search.lastinvoices) return this.getDoctypeTotal(doc);
      if (this.query === this.search.dueinvoices) {
        const due = moment(new Date(doc.dueDate)).diff(moment(new Date()), 'days') >= 0;
        this.pdfData.forEach(el => {
          const elDue = moment(new Date(el.dueDate)).diff(moment(new Date()), 'days') >= 0;
          if (el.issuer === doc.issuer && due === elDue) el.lineItems.forEach(li => sum += this.calcNet(el, li))
          if (el.issuer === doc.issuer && due === elDue) el.deductibleItems.forEach(li => sum += li.value)
          if (el.issuer === doc.issuer && due === elDue) el.progressPaymentInvoices?.forEach(li => sum += li.net)
        })
        return sum;
      }
      if (this.query === this.search.orders) {
        this.pdfData.forEach(el => {
          const rx = new RegExp(`^${type}`);
          if (el['recipient'] === doc['recipient'] && rx.test(el['code']))
            el.lineItems.forEach(li => sum += this.calcNet(el, li));
          if (el['recipient'] === doc['recipient'] && rx.test(el['code']))
            el.deductibleItems.forEach(li => sum += li.value);
          if (el['recipient'] === doc['recipient'] && rx.test(el['code']))
            el.progressPaymentInvoices?.forEach(li => sum += li.net);
          if (el.spos && el.oc['recipient'] === doc['recipient'] && type === '(PF)SPO') {
            el.spos.forEach(spo => sum+= spo.doc.lineItems[spo.pos-1] ? spo.doc.lineItems[spo.pos-1].piecePrice * spo.quantity : 0);
          }
        });
        return sum;
      }
    }
    this.pdfData.forEach(el => {
      if (el[section] === doc[section]) el.lineItems.forEach(li => sum += this.calcNet(el, li))
      if (el[section] === doc[section]) el.deductibleItems.forEach(li => sum += li.value)
      if (el[section] === doc[section]) el.progressPaymentInvoices?.forEach(li => sum += li.net)
    });
    return sum;
  }

  getDoctypeTotal(doc, filterField = null) {
    let type = doc.code.replace(/(.+NRK.).*/, '$1');
    if (type === 'INNRKA') type = '(PF)?(IN|CN)NRKA'
    if (type === 'INNRKG') type = '(PF)?(IN|CN)NRKG'
    let sum = 0;
    this.pdfData.forEach(el => {
      const rx = new RegExp(`^${type}`);
      if (filterField) {
        // eslint-disable-next-line max-len
        if (rx.test(el.code) && el[filterField] === doc[filterField]) el.lineItems.forEach(li => sum += this.calcNet(el, li));
        if (rx.test(el.code) && el[filterField] === doc[filterField]) el.deductibleItems.forEach(li => sum += li.value);
        if (rx.test(el.code) && el[filterField] === doc[filterField]) el.progressPaymentInvoices?.forEach(li => sum += li.net);
      } else {
        if (rx.test(el.code)) el.lineItems.forEach(li => sum += this.calcNet(el, li));
        if (rx.test(el.code)) el.deductibleItems.forEach(li => sum += li.value);
        if (rx.test(el.code)) el.progressPaymentInvoices?.forEach(li => sum += li.net);
      }
    })
    return sum;
  }

  showOfferData(idx) {
    return this.search.offers && /^OF/.test(this.pdfData[idx]['code']);
  }
  getOfferData(idx, field) {
    let val = (this.pdfData[idx] && this.pdfData[idx][field]) || '';
    if (field === 'offerStatus') {
      val = OfferStatusData.getName(val) || '';
    }
    if (field === 'statusComment') {
      val = OfferStatusData.getName(val, this.pdfData[idx]['offerStatus']) || '';
    }
    if (field === 'actionPoint') {
      val = (this.pdfData[idx]['actionPoint']
        && ActionPointData.get(this.pdfData[idx]['actionPoint'])?.name) || '';
    }
    if (field === 'offerStatusUser') {
      val = this.data.users.find(f => mongoId(f) === mongoId(this.pdfData[idx]['offerStatusUser']))?.short || '';
    }
    const p = val && (field === 'probability' || field === 'share') ? '%' : '';
    return val + p;
  }

  showOrOcInvTotal(idx) {
    if (!this.search.orders) return false;
    const curr = this.pdfData[idx]['code'];
    if (idx === this.pdfData.length - 1) {
      return !/^OR/.test(this.pdfData[idx]['code']);
      // this.getOrOcTotal(idx) > 0 && this.getOrInvTotal(idx) > 0; // /^OR/.test(curr);
    }
    const next = this.pdfData[idx+1]['code'];
    return ((/^(OC|PFIN|IN)/.test(curr) || this.pdfData[idx]?.spos) && /^OR/.test(next));
  }

  getOrTotal(idx) {
    let sum = 0;
    // idx--;
    while (this.pdfData[idx]?.['code'] && !/^OR/.test(this.pdfData[idx]['code'])) --idx;
    if (idx >= 0 && this.pdfData.length) {
      this.pdfData[idx].lineItems?.forEach(li => sum += this.calcNet(this.pdfData[idx], li));
      this.pdfData[idx].deductibleItems?.forEach(li => sum += li.value);
      this.pdfData[idx].progressPaymentInvoices?.forEach(li => sum += li.net);
    }
    return sum;
  }
  getOrOcTotal(idx) {
    let sum = 0;
    let doc = this.pdfData[idx];
    if (doc?.code && this.pdfData.length) while (idx >= 0 && !/^OR/.test(doc['code'])) {
      if (/^OC/.test(doc['code'])) doc.lineItems.forEach(li => sum += this.calcNet(this.pdfData[idx], li));
      if (/^OC/.test(doc['code'])) doc.deductibleItems.forEach(li => sum += li.value);
      if (/^OC/.test(doc['code'])) doc.progressPaymentInvoices?.forEach(li => sum += li.net);
      idx--;
      doc = this.pdfData[idx];
    }
    return sum;
  }
  getOrInvTotal(idx) {
    let sum = 0;
    let doc = this.pdfData[idx];
    if (doc?.code && this.pdfData.length) while (idx >= 0 && !/^OR/.test(doc['code'])) {
      if (/^(IN|PFIN)/.test(doc['code'])) doc.lineItems.forEach(li => sum += this.calcNet(this.pdfData[idx], li));
      if (/^(IN|PFIN)/.test(doc['code'])) doc.deductibleItems.forEach(li => sum += li.value);
      if (/^(IN|PFIN)/.test(doc['code'])) doc.progressPaymentInvoices?.forEach(li => sum += li.net);
      idx--;
      doc = this.pdfData[idx];
    }
    return sum;
  }

  getOrCnTotal(idx) {
    let sum = 0;
    let doc = this.pdfData[idx];
    if (doc?.code && this.pdfData.length) while (idx >= 0 && !/^OR/.test(doc['code'])) {
      if (/^CN/.test(doc['code'])) doc.lineItems.forEach(li => sum += this.calcNet(this.pdfData[idx], li));
      if (/^CN/.test(doc['code'])) doc.deductibleItems.forEach(li => sum += li.value);
      idx--;
      doc = this.pdfData[idx];
    }
    return sum;
  }

  getOrPfspoTotal(idx) {
    let sum = 0;
    let doc = this.pdfData[idx];
    if (doc?.code) while (idx >= 0 && !/^OR/.test(doc['code'])) {
      if (doc.spos?.length) {
        // doc.spos.forEach(spo => spo?.doc?.lineItems.forEach(li => sum += li.quantity * li.piecePrice));
        // doc.spos.forEach(spo => spo?.doc?.deductibleItems.forEach(li => sum += li.value));
        doc.spos.forEach(spo => sum += spo?.doc?.lineItems[spo.pos-1].piecePrice * spo?.quantity);
      }
      idx--;
      doc = this.pdfData[idx];
    }
    return sum;
  }

  findDocUpstream(idx: number, doctype: RegExp, accumulatorType: RegExp = null) {
    let ct = idx;
    const acc = [];
    while (--ct >= 0) {
      if (accumulatorType?.test(this.pdfData[ct]?.code)) acc.push(this.pdfData[ct].code);
      if (doctype.test(this.pdfData[ct]?.code)) return accumulatorType ? acc : ct as any;
    }
    return accumulatorType && acc;
  }

  findDocDownstream(idx: number, doctype: RegExp, accumulatorType: RegExp = null) {
    let ct = idx;
    const acc = [];
    while (++ct < this.pdfData.length) {
      if (accumulatorType?.test(this.pdfData[ct]?.code)) acc.push(this.pdfData[ct].code);
      if (doctype.test(this.pdfData[ct]?.code)) return accumulatorType ? acc : ct as any;
    }
    return accumulatorType && acc;
  }

  getDocSum(idx) {
    let sum = 0;
    const doc = this.pdfData[idx];
    if (doc?.lineItems?.length) doc.lineItems.forEach(li => sum += li.piecePrice * li.quantity);
    if (doc?.deductibleItems?.length) doc.deductibleItems.forEach(di => sum += di.value);
    if (doc?.progressPaymentInvoices?.length) doc.progressPaymentInvoices.forEach(di => sum += di.value);
    return sum;
  }

  getSpoSum(idx) {
    let sum = 0;
    const doc = this.pdfData[idx];
    if (doc?.spos?.length) doc.spos.forEach(spo => sum += spo?.doc?.lineItems[spo.pos-1].piecePrice * spo?.quantity);
    return sum;
  }

  getOcDataPerOr(idx) {
    let doc = this.pdfData[idx];
    if (!/^OC/.test(doc?.code)) return;
    let orIdx = this.findDocUpstream(idx, /^OR/);
    const numOcs = this.findDocDownstream(orIdx, /^OR/, /^OC/).length;
    if (numOcs < 2) return;
    let orSum = this.getDocSum(orIdx);
    let ocSum = this.getDocSum(idx);
    let invSum = 0;
    let cnSum = 0;
    let spoSum = 0;
    let ct = idx;
    do {
      doc = this.pdfData[++ct];
      if (/^IN/.test(doc?.code)) invSum += this.getDocSum(ct);
      if (/^CN/.test(doc?.code)) cnSum += this.getDocSum(ct);
      if (doc?.spos?.length) spoSum += this.getSpoSum(ct);
    } while(/^(IN|CN)/.test(doc?.code || doc?.spos?.length));
    return ({ orSum, ocSum, invSum, cnSum, spoSum });
  }

  calcNet(doc, lineItem) {
    // calced in backend
    // if (this.search.lastinvoices && doc.invoicePayment) {
    //   return lineItem.net * lineItem.invoicePercent / 100;
    // }
    // return lineItem.net;
    if (['CN', 'PFCN'].includes(CompilationTypeData.get(doc.type)?.code)) {
      return -Math.abs(lineItem.net);
    }
    return lineItem.net;
  }

  getQuantity(lineItem) {
    return lineItem?.extra?.reduce((a, c) => a + (+c.quantity), 0);
  }

  quantityColor(lineItem, col) { //and piecePriceColor
    const ocSum = this.getQuantity(lineItem);
    if (lineItem.quantity < ocSum && ['lineItems.quantity', 'lineItems.extra.quantity'].includes(col)) {
      return '#faa';
    } else if (lineItem.priceDateInvalid && ['lineItems.piecePrice', 'lineItems.extra.piecePrice'].includes(col)) {
      return '#faa'
    }
    return 'transparent';
  }

  getBackgroundColor(doc, item, pdf?, idx?) {
    if (item.compare) {
      const nameVal = this.getValue(doc, item.name, pdf, idx);
      const compareVal = this.getValue(doc, item.compare, pdf, idx);
      if (nameVal && compareVal && nameVal !== compareVal) {
        return '#faa';
      }
    }
    return null
  }

  getSpoData(idx) {
    let cnNet = 0, invNet = 0;
    for (let i = idx-1; i > 0; i--) {
      if (/^CN/.test(this.pdfData[i].documentNumber)) {
        cnNet += this.getOrCnTotal(i);
      }
      if (/^IN/.test(this.pdfData[i].documentNumber)) {
        invNet += this.getOrInvTotal(i);
      }
      if (/^OC/.test(this.pdfData[i].documentNumber)) {
        break;
      }
    }
    let spoNet = 0;
    this.pdfData[idx].spos.forEach(spo => spoNet += spo.quantity * spo.doc.lineItems[spo.pos-1].piecePrice);
    return { inv: invNet, cn: cnNet, spo: spoNet };
  }

  calcMargin() {
    if (this.container) {
      const oh = this.container.nativeElement.offsetHeight;
      const ch = this.container.nativeElement.getBoundingClientRect().height;
      return (ch - oh) / 2 - 30;
    }
    return 0;
  }

  toggleLegend() {
    
  }

  split(text: string, separator = '|') {
    return text.split(separator) || [];
  }

  async popupOrderReport(doc: CompilationModel) {
    let orders = [];
    if (doc.type === CompilationTypeData.get('OF').id) {
      orders = await this.api.findDownstreamDocumentByType(doc.code, CompilationTypeData.get('OR').id);
    } else {
      orders = [await this.api.findUpstreamDocumentByType(doc.code, CompilationTypeData.get('OR').id)];
    }

    if (orders.length) {
      this.popupReport.emit({ report: 'OR', docs: orders, reportData: {}});
    } else {
      this.toastr.warning(doc.code, 'no related order(s) found')
    }
  }

  getSelected(selection: string, options: {id: string, name: string}[]) {
    const sel = selection && options ? options.find(s => s.id.toString() === selection.toString()) : null;
    return sel ? sel.name : '';
  }

  onShowDocumentPreview(visible: boolean = true) {
    this.showDocumentPreview = visible;
  }

  setCompilation(compilation: CompilationModel) {

    this.compilation = compilation;

    if (this.compilation.showPackingPalletsInPdf === undefined) this.compilation.showPackingPalletsInPdf = true
    if (this.compilation.showPackingSummaryInPdf === undefined) this.compilation.showPackingSummaryInPdf = true
    // if (
    //   this.compilation.useOldPackingConditions === undefined 
    //   && (this.compilation.packingConditions && !this.compilation.packingConditions[0]?.items)
    // ) this.compilation.useOldPackingConditions = true;

  }

  // async setRelatedDocuments() {
  //   this.relatedDocuments = [];
  //   let top = this.compilation;
  //   let overflow = 10;

  //   do {
  //     this.relatedDocuments.unshift({
  //       doc: top,
  //       text: getDocumentNumber(top)
  //         + (top.issueDate ? ' (' + this.datePipe.transform(top.issueDate, 'yyyy-MM-dd') + ')' : ''),
  //     });
  //     top = (top.parent && await this.api.loadCompilationByCode(top.parent));
  //   } while (top && overflow--);

  //   if (overflow < 1) {
  //     console.error('overflow while setting related documents!');
  //     if (top) console.error('[' + top.code + ', ' + top.parent + ']');
  //   }

  //   const docs = await this.recurseDownstreamDocuments(this.compilation, 1, false);
  //   this.relatedDocuments.push(...docs);
  //   this.compilation.relatedDocuments = this.relatedDocuments.map(m => m.text).join('\n');
  // }

  async unlinkSpos(doc: CompilationModel) {
    // console.log('unlinking doc', doc, this.pdfData);
    // this.cdRef.detectChanges();
    // console.log(this.pdfData.flatMap(m => `${m.code} -> ${m.packingConditions}`));
    let isPalletized = false;
    let idx = 0;
    const docBoxes = {};
    for (const li of (doc.lineItems ?? [])) {
      if (!docBoxes[idx]) docBoxes[idx] = {}
      for (const ex of ((li as any)?.extra ?? [])) {
        if (!docBoxes[idx][ex.code]) docBoxes[idx][ex.code] = [];
        docBoxes[idx][ex.code] = await this.api.loadSpoBoxes({spo: ex.code});
        // console.log('has boxes', idx, ex.code, docBoxes[idx][ex.code]);
        const boxes = docBoxes[idx][ex.code]?.filter(box => box.docRef === doc.code);
        const pallets = Array.from(new Set(boxes.map(m => m.palletRef)))?.sort((a, b) => a > b ? 1 : -1);
        if (pallets?.filter(notNull => notNull)?.length) {
          this.toastr.danger(`${pallets.length > 1 ? 'Pallets '+pallets.join(',')+' are' : 'Pallet '+pallets[0]+' is'} assigned in Packing Details`, 'can\'t remove (PF)SPO');
          isPalletized = true;
          return;
        }
      }
      idx++;
    }
    if (!isPalletized) {
      const boxes = Object.values(docBoxes)?.map(Object.values)?.flat()?.filter(f => f.spo);
      // console.log('boxes to update', boxes);
      if (boxes?.length) {
        boxes.forEach(((el: SpoBoxModel) => {
          el.docRef = null;
          el.docRefPos = null;
          el.docRefProduct = null;
          el.status = 0 /*free*/;
          el.dispatchDate = null;
          el.palletRef = null;
        }));
        this.api.saveSpoBoxes(boxes);
      }

      // console.log('length:', doc.lineItems.flatMap(li => (li as any).extra)?.length, doc.lineItems.flatMap(li => (li as any).extra) )
      if (doc.lineItems.flatMap(li => (li as any).extra)?.filter(n => n)?.length) {
        const oc = await this.api.loadCompilationByCode(doc.code);
        oc.lineItems.forEach(li => li.pfspo = []);
        this.api.saveCompilation(oc).then(() => {
          doc.lineItems.forEach(li => (li as any).extra = []);
        });
      }
    }
    // this.spoBoxes[idx][el.code] = await this.api.loadSpoBoxes({spo: el.code});
    // const boxes = this.spoBoxes[idx][el.code]?.filter(box => box.docRef === this.compilation.code);
    // const pallets = Array.from(new Set(boxes.map(m => m.palletRef)))?.sort((a, b) => a > b ? 1 : -1);
    // if (pallets?.filter(notNull => notNull)?.length) {
    //   this.toastrService.danger(`${pallets.length > 1 ? 'Pallets '+pallets.join(',')+' are' : 'Pallet '+pallets[0]+' is'} assigned in Packing Details`, 'can\'t remove (PF)SPO');
    //   return;
    // }

    // item.pfspo = item.pfspo.filter(f => f.code !== el.code);
    // boxes.forEach(((el: SpoBoxModel) => {
    //   el.docRef = null;
    //   el.docRefPos = null;
    //   el.docRefProduct = null;
    //   el.status = EBoxStatus.free;
    //   el.dispatchDate = null;
    //   el.palletRef =null;
    // }));

    // this.api.saveSpoBoxes(boxes);

    // const doc = await this.api.loadCompilationByCode(this.compilation.code);
    // doc.lineItems[idx].pfspo = doc.lineItems[idx].pfspo.filter(f => f.code !== el.code);
    // // this.api.saveSpoBoxes(this.spoBoxes[idx][el.code]);
    //   this.api.saveCompilation(doc);
  }

  async downloadDocPdf(newDoc: CompilationModel, merge: boolean = false,
    copy: boolean = false, zip: boolean = false, attachmentsOnly: boolean = false) {

    this.setCompilation(await this.api.loadCompilationByCode(newDoc.code));

    this.data.setDocConfigMaps(this.compilation.type);

    await this.tree.loadDocumentTree(this.compilation);

    this.relatedDocuments = this.tree.getRelatedDocuments(this.compilation);
    
    this.showDocumentPreviewHidden = true
    this.showDocumentPreview = true;
    this.cdRef.detectChanges();
    await waitForVariable(this, 'documentPrinter', 500);
    await new Promise(resolve => {
      window.setTimeout(() => {
        this.documentPrinter.onDownloadPdf(merge, copy, zip, attachmentsOnly);
        resolve(true);
      }, 500);
    })
    this.showDocumentPreview = false;
    this.showDocumentPreviewHidden = false
  }

  async pdfPreview(doc: CompilationModel) {
    // const issuer = doc.code.match(/(nrk.)/i)[0].toLowerCase();
    // this.router.navigate(['/pages/erp/document/' + issuer], { queryParams: { code: doc.code, preview: true }})

    this.warehousingData.search = this.search;
    this.warehousingData = {...this.warehousingData}
    this.setCompilation(await this.api.loadCompilationByCode(doc.code));

    this.showPopupDocument = true;
  }

  async xlsTableValueChanged(col: any, data: any, rowidx, colidx) {
    const table = this.xlsData.table;
    const changed = data && table[rowidx][colidx] !== data;

    const idx = this.xlsData.header.findIndex(f => f.name === 'code')
    if (changed && idx >= 0) {
      // console.log('xls table update field', table[rowidx][idx], col.name, data);
      this.api.updateField(table[rowidx][idx], col.name, data);
    }

    // done in backend
    // if (['dueText', 'nextPaymentDate'].includes(col.name)) {
    //   // update 'last due update'
    //   const di = this.xlsData.header.findIndex(f => f.name === 'lastDueUpdate');
    //   const now = new Date()
    //   this.xlsData.table[rowidx][di] = now.toISOString().replace(/T.*/, '');
    //   // this.api.updateField(table[rowidx][idx], 'lastDueUpdate', now); updated in backend
    // }
    this.reloadData();
  }

  async onGenerateProjectOverviews() {
    this.profitMarginDocs = (await this.api.getCache(CacheType.docs, {codes: this.xlsData.map.map(m => m.code)}))?.docs;
    // console.log('onGenerateProjectOverviews', this.xlsData.map.map(m => m.code), this.profitMarginDocs);
    this.profitMarginWin.show();
  }

  downloadProfitMargins() {
    this.profitMargins.forEach(child => {
      child.downloadProfitCalcPdf(true);
    });
  }

  download(test: any) {
    console.log('download', test);
  }

  xlsFilterChanged() {
    this.setDisplayTable(0);
    this.xlsPage = 0;
  }

  xlsClearFilters() {
    this.currentTable.forEach(col => col.filter = '');
    this.setDisplayTable(0);
  }

  protected itemsPerPage = 25;
  protected pages = 1;
  setDisplayTable(pageMove: number) {

    if (this.xlsData.table.sheets) {

      const filter = this.xlsData.table.sheets.flatMap(f => f.data).filter(f => {
        return !this.currentTable.find((col, idx) => {
          return !RegExp(this.currentTable[idx].filter, 'i').test(f[idx])
        })
      });
  
      this.pages = Math.ceil(filter.length / this.itemsPerPage);
  
      if (pageMove) this.xlsPage += pageMove;
      if (this.xlsPage < 0) this.xlsPage = 0;
      if (this.xlsPage * this.itemsPerPage > filter.length) this.xlsPage--;
  
      this.xlsData.xls = { sheets: this.xlsData.table.sheets.map(sheet => ({
        name: sheet.name,
        data: sheet.data.filter(f => {
          return !this.currentTable.find((col, idx) => {
            return !RegExp(this.currentTable[idx].filter, 'i').test(f[idx])
          })
        })
      }))};
      this.xlsData.displayTable = filter.slice(this.xlsPage * this.itemsPerPage, (this.xlsPage + 1) * this.itemsPerPage);

      // console.log(this.xlsData.displayTable);

    } else {

      const filter = this.xlsData.table.filter(f => {
        return !this.currentTable.find((col, idx) => {
          return !RegExp(this.currentTable[idx].filter, 'i').test(f[idx])
        })
      });
  
      this.pages = Math.ceil(filter.length / this.itemsPerPage);
  
      if (pageMove) this.xlsPage += pageMove;
      if (this.xlsPage < 0) this.xlsPage = 0;
      if (this.xlsPage * this.itemsPerPage > filter.length) this.xlsPage--;
  
      this.xlsData.xls = filter;
      this.xlsData.displayTable = filter.slice(this.xlsPage * this.itemsPerPage, (this.xlsPage + 1) * this.itemsPerPage);
  
    }
  }

  getPdfData() {

    // if (this.warehousing && this.hideDispatched) {
    if (this.warehousing && this.dnStati) {

      // return this.pdfData.filter(f => f.packingStatus !== EPackingStatus.dispatched)
      const filter = this.dnStati;
      let data = this.pdfData.filter(f => {
        if (f.directDelivery) return false;
        if (f.packingStatus === EPackingStatus.readyForPacking && !f.confirmedByWarehousing) return true;
        let show = false;
        if (filter.notReadyForPacking && !f.packingStatus) show = true;
        if (filter.readyForPacking && f.packingStatus === EPackingStatus.readyForPacking) show = true;
        if (filter.readyForDispatch && f.packingStatus === EPackingStatus.readyForDispatch) show = true;
        if (filter.dispatched && f.packingStatus === EPackingStatus.dispatched) show = true;
        if (filter.delivered && f.packingStatus === EPackingStatus.delivered) show = true;
        if (filter.delivered && f.packingStatus === EPackingStatus.delivered && !f.completelyInvoiced) show = true;
        return show;
      });

      data = data.sort((a, b) => {

        const aIsConfirmedReady = a.packingStatus === EPackingStatus.readyForPacking && !a.confirmedByWarehousing;
        const bIsConfirmedReady = b.packingStatus === EPackingStatus.readyForPacking && !b.confirmedByWarehousing;
      
        if (aIsConfirmedReady && !bIsConfirmedReady) return -1;
        if (bIsConfirmedReady && !aIsConfirmedReady) return 1;

        return 0;

        // return a.packingStatus === EPackingStatus.dispatched && b.packingStatus !== EPackingStatus.dispatched 
        //   ? -1 : b.packingStatus === EPackingStatus.dispatched && a.packingStatus !== EPackingStatus.dispatched
        //     ? 1 : 0
      })

      this.docCodes.emit(data.map(m => m.code));
      return data;
    }

    // console.log('getPdfData', this.query.reverseSort, this.query, this.search, this.pdfData, this.pdfData.reverse());
    
    return !this.reverse ? this.pdfData : this.pdfData.reverse();

  }

  openMessage(message: WarehousingModel) {
    this.currentMessage = message;
    this.messageWindow.messagingMode = this.messagingMode.messageWindow;
    this.messageWindow.show(message);
  }

  canShowMessage(message: WarehousingModel, button = false) {
    // // console.log('message to show', message);
    // return (mongoId(message.user) !== mongoId(this.auth.user))
    //   && !message.isReadBy.find(f => f.user === mongoId(this.auth.user)) 
    //   && !message.deleted
    //   // && (!button || (mongoId(message.recipient) === mongoId(this.auth.user) && !message.isReadBy.length));
    //   // && (!message.recipient || (mongoId(message.recipient) === mongoId(this.auth.user)));

    // console.log('message to show', message);
    return !message.isReadBy.find(f => mongoId(f.user) === mongoId(this.auth.user)) 
      && !message.deleted
      // && (!button || (mongoId(message.recipient) === mongoId(this.auth.user) && !message.isReadBy.length));
      // && (!message.recipient || (mongoId(message.recipient) === mongoId(this.auth.user)));
  }

  getMessageClass(message: WarehousingModel) {
    if (mongoId(message.recipient) === mongoId(this.auth.user) || mongoId(message.user) === mongoId(this.auth.user)
      || message.children?.find(f => mongoId(f.recipient) === mongoId(this.auth.user) || mongoId(f.user) === mongoId(this.auth.user))) {
      return 'msg-btn btn btn-primary'
    } else {
      return 'msg-btn btn btn-default'
    }
  }

  getMailFromTo(message: WarehousingModel) {
    const sender = this.data.users.find(f => mongoId(f) === mongoId(message.user));
    const recipient = this.data.users.find(f => mongoId(f) === mongoId(message.recipient));
    return `${sender?.short} → ${recipient?.short || 'All'}`
  }

  async openOfferSettings(doc: any) {
    this.currentOffer = await this.api.loadCompilationByCode(doc?.code);
    if (!this.currentOffer.offerData) {
      this.currentOffer.offerData = new OfferData();
    } else {
      this.statusCommentOptions = OfferStatusData.getOptions(+this.currentOffer.offerData.offerStatus);
    }
    this.offerSettingsWindow.show();
  }

  offerStatusChanged() {
    this.statusCommentOptions = OfferStatusData.getOptions(+this.currentOffer.offerData.offerStatus);
  }

  async toggleShowInReport(docRef) {
    const doc = await this.api.loadCompilationByCode(docRef?.code);
    if (!doc.offerData) doc.offerData = new OfferData();
    if (!doc.offerData.dontShowInReport) {
      doc.offerData.dontShowInReport = true;
    } else {
      doc.offerData.dontShowInReport = false
    }
    docRef.dontShowInReport = doc.offerData.dontShowInReport ;
    this.api.saveCompilation(doc);
  }

  showInternal(doc) {
    return /^(OC|DN|IN|PFIN)/.test(doc?.code) && this.auth.user.admin;
  }

  saveOfferSettings() {
    this.currentOffer.offerData.updatedAt = new Date();
    this.currentOffer.offerData.user = this.auth.user;
    this.api.saveCompilation(this.currentOffer);
    this.reloadData(true);
  } 

  async openMessaging(doc: CompilationModel) {
    this.messageWindow.reset();
    this.messageWindow.compilation = doc; 
    this.messageWindow.messagingMode = this.messagingMode.messageWindow;
    await this.messageWindow.show();
    // console.log('openMessaging', doc, this.messageWindow.compilation?.code);
  }

  onMessagingClose(message: WarehousingModel) {
    if (message) {
      const doc = this.pdfData.find(f => f.code === message.code);
      let msg: WarehousingModel;
      if (doc) {
        msg = doc.messages?.find(f => f.subject === message.subject && f.message === message.message && f.timestamp === message.timestamp);
      } else {
        msg = this.data.warehousingMessages?.find(f => f.subject === message.subject && f.message === message.message && f.timestamp === message.timestamp);
      }
      // console.log('onmessagingclose', message.isReadBy, doc, msg, message);
      if (msg) msg.isReadBy = message.isReadBy;
    }
  }

  addDueinfoItem() {
    // this.saveCurrentDueInfo();
    const current = this.dueInfoData[this.currentDueInfoCode];
    current.info.unshift({
      user: mongoId(current.dueUser),
      dueDate: current.dueDate,
      nextPaymentDate: current.nextPaymentDate,
      dueText: current.text,
      lastUpdate: new Date(),
    })
    this.dueInfoData[this.currentDueInfoCode] = {
      dueUser: mongoId(this.auth.user),
      dueDate: null,
      nextPaymentDate: null,
      text: '',
      info: current.info,
    }

  }

  async saveCurrentDueInfo() {
    const info = this.dueInfoData[this.currentDueInfoCode];
    const doc = await this.api.loadCompilationByCode(this.currentDueInfoCode);

    if (info && doc) {
      doc.dueUser = mongoId(this.auth.user);
      doc.dueText = info.text;
      doc.dueDate = info.dueDate;
      doc.nextPaymentDate = info.nextPaymentDate;
      await this.api.saveCompilation(doc);
      this.toastr.success('Due Info successfuly saved', 'Due Info')
      this.reloadData();
    }
    
  }

  async dueInfoChanged(row: any, idx: number) {
    // // console.log( this.currentDueInfoCode, this.dueInfoPopupData[idx], this.dueInfoData, row, idx);
    // const doc = await this.api.loadCompilationByCode(row[0]);
    // if (doc) {
    //   doc.dueText = doc.dueText ? `${doc.dueText}\n` : '' 
    //     + (this.dueInfoPopupData[idx].reminder1 ? `1st reminder ${this.dueInfoPopupData[idx].reminder1.replace(/T.*/,'')}\n` : '')
    //     + (this.dueInfoPopupData[idx].reminder2 ? `2nd reminder ${this.dueInfoPopupData[idx].reminder2.replace(/T.*/,'')}\n` : '')
    //     + (this.dueInfoPopupData[idx].reminder3 ? `3rd reminder ${this.dueInfoPopupData[idx].reminder3.replace(/T.*/,'')}\n` : '')
    //     + (this.dueInfoPopupData[idx].text ? this.dueInfoPopupData[idx].text : '')
    //   // console.log('due text', this.dueInfoPopupData[idx], doc.dueText);
    //   this.dueInfoData[idx].dueText = doc.dueText;
    //   await this.api.saveCompilation(doc);
    //   this.toastr.success('Due Info successfuly saved', 'Due Info')
    //   this.reloadData(true);
    // }

    const doc = await this.api.loadCompilationByCode(row[0]);

    const dueTextArr = doc.dueInfo?.[0] ? [] : [doc.dueText]; //doc.dueInfo?.[0] ? [doc.dueText] : [];

    if (this.dueInfoPopupData[idx].editMode) {
      dueTextArr.push(this.dueInfoPopupData[idx].dueText);
    } else {
      if (this.dueInfoData[idx]?.[0]?.dueText) {
        dueTextArr.push(this.dueInfoData[idx]?.[0]?.dueText);
      }
      if (this.dueInfoPopupData[idx].reminder) { 
        dueTextArr.push(this.dueInfoPopupData[idx].reminder + ' ' + this.dueInfoPopupData[idx].reminderDate.toISOString().replace(/T.*/,''));
      }
      if (this.dueInfoPopupData[idx].dueText) {
        dueTextArr.push(this.dueInfoPopupData[idx].dueText);
      }
    }

    const item = {
      user: mongoId(this.auth.user),
      dueDate: this.dueInfoPopupData[idx].dueDate,
      nextPaymentDate: this.dueInfoPopupData[idx].nextPaymentDate,
      lastDueUpdate: new Date(),
      dueText: dueTextArr.join('\n'),
    }

    doc.dueText = item.dueText;
    doc.dueUser = mongoId(this.auth.user);

    if (!doc.dueInfo?.length) {
      doc.dueInfo = [item];
    } else if (this.dueInfoPopupData[idx].editMode) {
      doc.dueInfo[0] = item;
    } else {
      doc.dueInfo.unshift(item);
    }

    await this.api.saveCompilation(doc);
    this.toastr.success('Due Info successfuly saved', 'Due Info')
    this.reloadData(true);

    // console.log('due data', this.dueInfoData[idx], this.dueInfoPopupData[idx].reminderDate, item, doc.dueInfo);
  }

  inventoryPdfData = {} as any;
  async onCreateInventoryList(data = this.xlsData, pdf = false) {

    const columns = [
      { header: '✓', key: 'cb', width: 4, alignment: { horizontal: 'center', vertical: 'middle' } },
      { header: 'Box#', key: 'boxNr', width: 4, alignment: { horizontal: 'center', vertical: 'middle' } },
      { header: 'Box ID', key: 'boxId', width: 5, alignment: { horizontal: 'center', vertical: 'middle' } },
      { header: 'Product Name', key: 'spoCalcName', width: 19, alignment: { horizontal: 'left', vertical: 'middle' } },
      { header: 'Product Dimensions', key: 'spoDimensions', width: 17, alignment: { horizontal: 'left', vertical: 'middle' } },
      { header: 'Q/Box', key: 'quantity', width: 5, alignment: { horizontal: 'center', vertical: 'middle' } },
      { header: 'TC #', key: 'tc', width: 7, alignment: { horizontal: 'center', vertical: 'middle', wrapText: true } },
      { header: 'Lot #', key: 'lot', width: 11, alignment: { horizontal: 'center', vertical: 'middle', wrapText: true } },
      { header: 'PFSPO #', key: 'spo', width: 15, alignment: { horizontal: 'left', vertical: 'middle' } },
      { header: 'Pos', key: 'spoPos', width: 2, alignment: { horizontal: 'center', vertical: 'middle' } },
      { header: 'ETA AT Date', key: 'arrivalDate', width: 10, alignment: { horizontal: 'center', vertical: 'middle' } },
      { header: 'Shelf Life Date', key: 'shelfLifeDate', width: 10, alignment: { horizontal: 'center', vertical: 'middle' } },
      // { header: 'Remaining Max Shelf Life at Dispatch', key: 'maxShelfLife', width: 10, alignment: { horizontal: 'center', vertical: 'middle' } },
      // { header: 'First Priority Box Label', key: '', width: 10, alignment: { horizontal: 'center', vertical: 'middle' } },
      // { header: 'shelf Life < 6 Months', key: 'shelfLifeLt6', width: 10, alignment: { horizontal: 'center', vertical: 'middle' } },
      // { header: 'shelf Life < 12 Months', key: 'shelfLifeLt12', width: 10, alignment: { horizontal: 'center', vertical: 'middle' } },
      // { header: 'Reinspection Needed From', key: 'reinspectionDate', width: 10, alignment: { horizontal: 'center', vertical: 'middle' } },
      // { header: 'Remaining Shelf Life %', key: 'remainingShelfLife', width: 10, alignment: { horizontal: 'center', vertical: 'middle' } },
      { header: 'Remark', key: 'remark', width: 16, alignment: { horizontal: 'left', vertical: 'middle' } },
      
      {key: 'spoCustomerReference', hidden: true},
      {key: 'spoCountry', hidden: true},
      {key: 'spoCalcCode', hidden: true},
    ]

    if (pdf) {  // convert pdf data to table data
      // this.onCreateInventoryList({table: this.pdfData.map(m => Object.values(m)), header: Object.keys(this.pdfData[0]).map(m => ({name: m}))}, true);
      data = {
        header: columns.map(m => ({name: m.key})),
        table: data.map(m => columns.map(c => m[c.key]))
      }
    }

    // console.log('search', this.search, data, pdf);


    const font = 'Calibri';
    
    const intermediate: any = [];

    data.table.forEach(row => {
      // console.log(typeof row, row);
      intermediate.push(row.reduce((a, c, idx) => {
        if (data.header[idx]) {
          const key = data.header[idx].name;
          if (key === 'tc' || key === 'lot') c = `${c}`.replace(/, /g, '\n');
          a[key] = c
        }
        return a;
      }, {}));
    })

    function compareValues(key: string, order: 'asc' | 'desc' = 'asc') {
      return function innerSort(a: any, b: any) {
          if (!a[key]) return 1;
          if (!b[key]) return -1;
          if (!a[key] && !b[key]) return 0;
          const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key];
          const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key];
          let comparison = 0;
          if (varA > varB) {
              comparison = 1;
          } else if (varA < varB) {
              comparison = -1;
          }
          return (
              (order === 'desc') ? (comparison * -1) : comparison
          );
        };
    }
  
    const sorted = intermediate.sort((a, b) => {
        const spoCountryComparison = compareValues('spoCountry')(a, b);
        if (spoCountryComparison !== 0) return spoCountryComparison;
    
        const spoCustomerReferenceComparison = compareValues('spoCustomerReference')(a, b);
        if (spoCustomerReferenceComparison !== 0) return spoCustomerReferenceComparison;
    
        const spoCalcNameComparison = compareValues('spoCalcName')(a, b);
        if (spoCalcNameComparison !== 0) return spoCalcNameComparison;
    
        const spoDimensionsComparison = compareValues('spoDimensions')(a, b);
        if (spoDimensionsComparison !== 0) return spoDimensionsComparison;

        const spoCalcCodeComparision = compareValues('spoCalcCode')(a, b);
        if (spoCalcCodeComparision !== 0) return spoCalcCodeComparision;
    
        return compareValues('boxId')(a, b);
    });

    // build table
    let table = {}
    const totalCounts = {}
    sorted.forEach(row => {

      if (!table[`${row['spoCustomerReference']}|${row['spoCalcCode']}`]) {
        table[`${row['spoCustomerReference']}|${row['spoCalcCode']}`] = [];
      }
      table[`${row['spoCustomerReference']}|${row['spoCalcCode']}`].push(row);

    })

    Object.keys(table).forEach(product => {
      table[product] = table[product].sort((a, b) => {

        const spoComparision = compareValues('spo')(a, b);
        if (spoComparision !== 0) return spoComparision;
    
        const arrivalDateComparision = compareValues('arrivalDate')(a, b);
        if (arrivalDateComparision !== 0) return arrivalDateComparision;

        const boxComparision = compareValues('boxId')(a, b);
        if (boxComparision !== 0) return boxComparision;

      })
    })


    Object.keys(table).forEach(product => {
      totalCounts[product] = table[product].reduce((a, c) => a + c.quantity, 0);
    })

    // console.log('------> table 2', table)



    const workbook = new ExcelJS.Workbook();

    const sheet = workbook.addWorksheet('Inventary List', {
      pageSetup: { 
        paperSize: 9, 
        orientation: 'landscape',
        margins: {
          top: 0.3,
          left: 0.4,
          bottom: 0.3,
          right: 0.3,
          header: 0,
          footer: 0,
        } 
      }
    });

    const pt = (mm) => mm * 2.83465;
    const mm = (pt) => pt * 0.352778;

    if (pdf) {
      this.inventoryPdfData = {
        columns: columns,
        rows: table,
        totalCounts: totalCounts,
      }
      // console.log('inventory pdf data', this.inventoryPdfData, table, columns);
      return;
    }

    function addHeader(product, page = '') {

      const header = [
        sheet.addRow([table[product][0].spoCountry]),
        sheet.addRow([table[product][0].spoCustomerReference]),
        sheet.addRow([`${[table[product][0].spoCalcName]}; ${[table[product][0].spoDimensions]} (${[table[product][0].spoCalcCode]}) - Total ${totalCounts[product]} pc ${page ? '[Sheet ' + page + ']' : ''}`]),
      ]
      sheet.addRow([' ']);
      header.forEach(row => row.eachCell((cell => cell.font = {
        name: font,
        family: 2,
        size: 11,
      })));
 
      const row = sheet.addRow(columns.map(c => c.header));
      row.eachCell((cell, idx) => {
        cell.font = { name: font, family: 2, size: 8, bold: true } 
        cell.fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'FFDDDDDD'}
        };
        cell.border = {
          top: {style:'thin', color:{argb:'FF000000'}},
          left: idx === 1 ? {style:'thin', color:{argb:'FF000000'}} : {},
          bottom: {style:'thin', color:{argb:'FF000000'}},
          right: idx === columns.length ? {style:'thin', color:{argb:'FF000000'}} : {}
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' }      
      });
    }

    const getCurrentHeight = (startRow) => {
      let height = 0;
      for (let i = startRow; i <= sheet.lastRow.number; i++) {
        height += sheet.getRow(i).height > 0 ? sheet.getRow(i).height : sheet.properties.defaultRowHeight;
      }
      // console.log('height', sheet.getRow(0), height, mm(height));
      return mm(height);
    }


    sheet.columns = columns.map(m => ({ key: m.key, width: m.width }));

    const heading = sheet.addRow(['Inventory Box List']);
    heading.height = 20;
    heading.eachCell((cell => cell.font = {
      name: font,
      family: 2,
      size: 16,
      bold: true, 
    }))
    sheet.addRow([' '])

    let startRow = 1;

    Object.keys(table).forEach((product, pidx) => {

      if (pidx > 0) startRow = sheet.lastRow.number;

      addHeader(product);

      table[product].forEach((rec, ridx) => {

        const lines = Math.max(rec['tc']?.split('\n').length, rec['lot']?.split('\n').length);
        const height = lines > 1 ? pt(6*lines) : pt(8.5);

        if (getCurrentHeight(startRow) > 195 - mm(height) /*mm*/ && ridx !== table[product].length - 1) {
          startRow = sheet.lastRow.number + 1;
          sheet.lastRow.addPageBreak();
          addHeader(product);
        }


        const row = sheet.addRow(columns.map(c => rec[c.key] || ' '));
        row.eachCell((cell, col) => { 
          cell.alignment = columns[col-1].alignment as any 
          cell.border = {
            top: {style:'thin', color:{argb:'FF000000'}},
            left: {style:'thin', color:{argb:'FF000000'}},
            bottom: {style:'thin', color:{argb:'FF000000'}},
            right: {style:'thin', color:{argb:'FF000000'}}
          };
          cell.font = {
            name: font,
            family: 2,
            size: 10
          }
        } );
        row.height = height;
        // row.getCell('remark').value = `${row.height.toFixed(2)} / ${getCurrentHeight(startRow).toFixed(2)} (${lines})`;

      })

      sheet.addRow([]);
      sheet.lastRow.addPageBreak();

    })

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, CommonPrinter.getPDFFilename('boxes', this.search));
    
  }

  scrollToDoc(code: string) {
    const el = document.getElementById(`rep_${code}`);
    // console.log('scroll to doc', code, el);
    if (el) {
      el.scrollIntoView();
    }
  }

  isMachinery() {
    const ma = this.data.businessUnits.filter(f => ['VI', 'MM', 'BA', 'AM', 'FX'].includes(f.code)).map(f => mongoId(f));
    return ma?.some(f => this.search.noninvoiced?.businessUnits?.includes(mongoId(f)))
  }

  getNonInvoicedBU() {
    const em = this.data.businessUnits.filter(f => ['EM'].includes(f.code)).map(f => mongoId(f));
    const ma = this.data.businessUnits.filter(f => ['VI', 'MM', 'BA', 'AM', 'FX'].includes(f.code)).map(f => mongoId(f));
    if (em.length === this.search.noninvoiced?.businessUnits?.length && em?.every(f => this.search.noninvoiced?.businessUnits?.includes(mongoId(f)))) {
      return '(Energy Materials) ';
    } else if (ma.length === this.search.noninvoiced?.businessUnits?.length && ma?.every(f => this.search.noninvoiced?.businessUnits?.includes(mongoId(f)))) {
      return '(Machinery) ';
    }
    return ''
  }

  async openDocEditor(doc: any) {
    const oc = await this.api.loadCompilationByCode(doc.code);
    await this.tree.loadDocumentTree(oc);
    this.data.setDocConfigMaps(oc.type);
    this.docEditor.open({
      compilation: oc,
    });
  }

  async saveDocEditor() {
    const oc = this.docEditor?.data?.compilation;
    if (!oc) return;
    try {
      this.docEditorReportDates?.syncDisplayDates();
      console.log('oc edit before', oc.edit);
      oc.editCount += 1;
      oc.issueDate = new Date();
      this.data.updateDateHistory(oc, this.auth.user?.short);
      console.log('oc edit after', oc.edit);
      await this.api.saveCompilation(oc);
      await this.docEditorReportDates?.save();
      await this.api.refreshCache();
      this.downloadDocPdf(oc);
      this.toastr.success(`Document '${oc.code}' saved!`, 'Success');
    } catch (e) {
      console.error('error saving doc editor dates', e);
      this.toastr.danger(`Could not save dates for '${oc.code}'`, 'Error');
    } finally {
      this.docEditor.close();
      this.reloadData(true, false);
    }
  }

  onSaveCSSPO(doc: CompilationModel) {
    this.downloadDocPdf(doc);
  }

}
